export let langArr = {};
langArr.en = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Multisession is not allowed',
'multisession_message': 'Your session has been terminated because the same account was opened in another tab or window.',
'session_inactivity_warning': 'Due to inactivity, your session is about to expire.',
'autoplay_confirmation': 'Total amount for autoplay rounds',
'balance_before': 'Balance before',
'balance_after': 'Balance after',

};
langArr.sw = {
'loading': 'Inapakia',
'hotkeys': 'Vifunguo vya haraka',
'hotkeys_enabled': 'Vifunguo vya haraka vimewezeshwa',
'enable_hotkeys_checkbox': 'Washa vifunguo vya haraka kwa kuweka alama.',
'make_bet': 'Weka dau',
'double_bet': 'Ongeza dau mara mbili',
'halve_bet': 'Punguza dau kwa nusu',
'min_bet': 'Kiasi cha chini cha dau',
'cashout_key': 'Toa pesa',
'walk_next_line': 'Tembea kwa mstari unaofuata',
'max': 'Kikomo',
'easy': 'Rahisi',
'medium': 'Kati',
'hard': 'Ngumu',
'daredevil': 'Mjasiri',
'max_profit': 'Faida ya juu kabisa',
'manual': 'Mwongozo',
'auto': 'Otomatiki',
'bet_amount': 'Kiasi cha dau',
'difficulty': 'Ugumu',
'payout_on_win': 'Malipo kwa Ushindi',
'number_of_bets': 'Idadi ya Madau',
'on_win': 'Wakati wa Ushindi',
'on_loss': 'Wakati wa Kupoteza',
'stop_on_profit': 'Acha kwenye Faida',
'stop_on_loss': 'Acha kwenye Hasara',
'reset': 'Weka upya',
'increase_by': 'Ongeza kwa',
'cashout': 'TOA FEDHA',
'start_game': 'BETI',
'start_auto_game': 'ANZA',
'difficulity_info': 'Maelezo ya Ugumu',
'chance_collision': 'Nafasi ya kugongana kwa kila mchezo',
'evry_25_lane': 'kwa kila njia 25',
'insufficient_funds': 'Fedha hazitoshi',
'cashout_inactivity': 'Malipo ya kiotomatiki kwa kutofanya kazi',
'time_running_out': 'Muda unakaribia kuisha! Cheza sasa au tiketi yako itaondolewa moja kwa moja baada ya sekunde 30',
'there_was_error': 'KUNA HITILAFU, JARIBU TENA AU PAKIA UPYA',
'detailed_game_rules': 'Sheria za Mchezo kwa Kina',
'general_rules': 'SHERIA ZA JUMLA',
'general_rules_p1': '• Kizidishi huanza kwa 1 na kupanda hadi ',
'general_rules_p2': '• Ushindi huhesabiwa kwa kuzidisha dau na kizidishi kinachoonyeshwa kwenye kila hatua.',
'general_rules_p3': '• Ikiwa kiwango cha juu cha malipo kitafikiwa, mchezo utajitoa pesa kiotomatiki kwa kiwango cha juu cha malipo.',
'progressive_jackpot': 'JACKPOT INAYOENDELEA',
'progressive_jackpot_ss': 'Njia ya jackpot na uwezekano wa kushinda',
'progressive_jackpot_p1': '% ya kila dau huwekwa kwenye mfuko wa jackpot inayoendelea.',
'progressive_jackpot_p2': 'Jackpot hutolewa kwa kutumia mbinu ya "Mystery" au "must-hit-by". Thamani ya kila jackpot ya "must-hit-by" huamuliwa mara tu baada ya jackpot iliyotangulia kushindwa kwa kutumia jenereta ya namba za bahati nasibu na kuhifadhiwa kama thamani iliyofichwa kwenye hifadhidata ya mbali. Thamani hiyo imefichwa na haijulikani.',
'progressive_jackpot_p3': 'Mara tu thamani ya "must-hit-by" inapofikiwa, mchezaji wa kwanza kuweka dau baada ya hapo atakuwa na nafasi ya kushinda jackpot. Alama ya jackpot itaonekana kwenye njia nasibu, na jackpot itashindwa ikiwa mchezaji atafikia njia yenye alama hiyo. Ikiwa mchezaji hatafikia njia yenye alama ya jackpot kwa sababu ya kujitoa au kuanguka, mchezaji mwingine nasibu atakayeweka dau ataona alama ya jackpot na kupata nafasi ya kushinda. Mchakato huu utaendelea hadi jackpot ishindwe. Ni tiketi/mchezaji mmoja tu anaweza kushinda jackpot.',
'progressive_jackpot_p4': 'KUMBUKA: Raundi ya bonasi haichangii mfuko wa jackpot. Wakati wa raundi ya bonasi, jackpot haiwezi kushindwa.',
'showdown': 'MCHUANO',
'showdown_ss': 'Mraba mwekundu, mahali pa mgongano fulani',
'showdown_p1': 'Baada ya mchezaji kujitoa, mraba mwekundu utaonyeshwa mahali ambapo mgongano ungetokea ikiwa mchezaji angeendelea kuruka njia.',
'return_to_player': 'KUREJESHA KWA MCHEZAJI',
'return_to_player_p1': 'Rejesho la kinadharia kwa mchezaji (RTP) ni ',
'return_to_player_p2': 'Asilimia za RTP hufuatiliwa na kuthibitishwa kila mara na taasisi huru.',
'disconnection_policy': 'SERA YA KUKATIKA MTANDAO',
'disconnection_policy_p1': 'Ikiwa muunganisho utakatika baada ya dau kuwekwa, dau halitafutwa mara moja. Ikiwa kutokuwepo kwa mchezaji kutafikia ',
'disconnection_policy_p2': 'dau litajitowa kiotomatiki na pesa zitawekwa kwenye akaunti ya mchezaji.',
'network_latency': 'UCHELEWESHWAJI WA MTANDAO',
'network_latency_p1': 'Ucheleweshaji wa mtandao ni sehemu isiyoepukika ya muunganisho wa Intaneti. Tunachukulia dau na utoaji wa pesa kuwa halali tu wakati yanapofika kwenye seva zetu, bila kujali muda wa ucheleweshaji wa mtandao.',
'sound': 'SAUTI',
'sound_p1': 'Mchezo umebuniwa kwa kuzingatia muziki wa mandhari nzuri na athari za sauti. Ikiwa unataka kulemaza muziki na/au athari za sauti, unaweza kufanya hivyo kupitia menyu ya mchezo.',
'error_handling': 'USHUGHULIKIAJI WA MAKOSA',
'error_handling_p1': 'Endapo kutatokea hitilafu, timu yetu ya msaada itajaribu kutatua tatizo haraka iwezekanavyo na kuendelea na mchezo wa kawaida. Iwapo kuna tatizo na mchezo wenyewe, dau zote zitafutwa na kiasi cha dau kitarudishwa kwa wachezaji.',
'max_payout': 'Malipo ya juu zaidi ni ',
'max_bet_is': 'Dau la juu zaidi ni ',
'min_bet_is': 'Dau la chini zaidi ni ',
'per_bet': 'kwa kila dau.',
'malfunction_voids': 'Hitilafu inabatilisha malipo yote na michezo yote.',
'attention_jackpot': 'Tahadhari, Jackpot kwenye njia ',
'lane': 'njia',
'congratulations': 'hongera',
'you_won': 'umeshinda',
'balance': 'salio',
'time': 'muda',
'jackpot': 'jackpot',
'escaped': 'UMEJITOA',
'max_win': 'USHINDI WA JUU ZAIDI',
'check_internet': 'Tafadhali angalia muunganisho wako wa intaneti',
'websocket_disconected': 'Muunganisho wa WebSocket umekatika',
'websocket_connection_error': 'Hitilafu ya muunganisho wa WebSocket!',
'session_expired': 'Kipindi kimeisha, tafadhali pakia upya',
'remaining_bets': 'Dau Zilizobaki',
'stop_autoplay': 'SIMAMISHA',
'autoplay_and_autocashout': 'MCHEZO KIOTOMATI NA MALIPO KIOTOMATI',
'autoplay_and_autocashout_ss': 'Chaguo kati ya mwongozo na mchezo wa moja kwa moja',
'autoplay_and_autocashout_p1': 'Mchezaji anaweza kuwezesha chaguo la mchezo wa moja kwa moja ambapo dau huwekwa kiotomatiki kwa kila raundi mpya kwa kutumia kiasi cha dau kutoka dau la awali.',
'autoplay_and_autocashout_p2': 'Kizidishi cha utoaji wa pesa kiotomatiki kinaweza kuchaguliwa kutoka kwenye skrini ya mchezo, na kikishawekwa, mchezo utajitoa pesa kiotomatiki ikiwa mchezaji hatapoteza kabla ya kufikia kizidishi kilichochaguliwa.',
'autoplay_and_autocashout_p3': 'Idadi ya juu kabisa ya raundi za mchezo wa moja kwa moja ni ',
'autoplay_button_label': 'Kuanzisha, chagua njia.',
'min_bet_amount_is': 'Kiasi cha chini cha dau ni',
'bonus_rounds': 'RAUNDI ZA BONASI',
'bonus_rounds_ss': 'Raundi za Bonasi zenye muda wa uhalali',
'bonus_rounds_p1': 'Mchezaji anaweza kupewa raundi ya bonasi (yaani dau la bure) kulingana na ofa ya kasino. Picha ibukizi itaonekana kwenye skrini ikimjulisha mchezaji kuhusu raundi za bonasi alizopewa, idadi ya dau, kiasi kwa kila dau, na kwa hiari, muda wa uhalali.',
'bonus_rounds_p2': 'Mara baada ya kutunukiwa, mchezaji anaweza kuchagua wakati wa kuanza raundi ya bonasi. Mara tu raundi ya bonasi inapowashwa, dau la kiotomatiki lenye dau maalum linawekwa, na ni juu ya mchezaji kujitoa pesa wakati wowote.',
'bonus_rounds_p3': 'Raundi za bonasi zinaweza kuwa na kikomo cha muda, baada ya hapo zinakuwa batili na haziwezi kutumika. Muda wa uhalali, ikiwa upo, unaonyeshwa chini ya raundi ya bonasi.',
'bonus_rounds_p4': 'Kutokuwepo kwa mchezaji kunaweza kusababisha kufutwa kwa raundi ya bonasi inayofanya kazi. Katika hali hii, idadi ya raundi za bonasi inapungua, na salio la mchezaji linabaki vile vile.',
'valid_until': 'halali hadi',
'bonus': 'bonasi',
'rounds': 'mizunguko',
'win_eur': 'Shinda EUR',
'complete_your_bet': 'Tafadhali kamilisha dau lako kwanza',
'complete_auto_play': 'Tafadhali kamilisha mchezo kiotomatiki kwanza',
'yes': 'ndio',
'no': 'hapana',
'play_bonus_rounds': 'Cheza mizunguko ya bonasi?',
'bet_history': 'Historia ya Dau',
'jackpot_history': 'Historia ya Jackpot',
'ticket_id': 'ID ya Tiketi',
'created': 'ilianzishwa',
'currency': 'sarafu',
'bet': 'dau',
'bet_eur': 'dau EUR',
'lanes': 'njia',
'cars': 'magari',
'multiplier': 'kizidishi',
'win': 'ushindi',
'no_betting_history': 'Hakuna historia ya dau. Weka dau, na itaonekana hapa.',
'no_jackpot_history': 'Hakuna historia ya jackpot inayopatikana.',
'date': 'tarehe',
'user': 'mtumiaji',
'bet_already_active': 'Dau tayari linaendelea',
'please_play_the_game_in_portait_mode': 'Tafadhali cheza mchezo katika mtazamo wima.',
'bonus_history': 'Historia ya bonasi',
'bonus_type': 'Aina ya bonasi',
'no_bonus_history': 'Hakuna historia ya bonasi inayopatikana.',
'game_menu': 'Menyu ya Mchezo',
'game_menu_ss': 'Kutoka kushoto: Nyumbani, Historia ya Dau, Kanuni za Mchezo, Vifupisho vya Kibodi, Mipangilio ya Sauti FX, Muziki',
'game_menu_p1': 'Kupitia menyu ya mchezo, wachezaji wanaweza kudhibiti chaguo za sauti, vifupisho vya kibodi, na kufungua historia ya mchezo pamoja na kanuni za mchezo.',
'game_menu_p2': 'Historia ya mchezo itaonyesha dirisha lenye dau za awali na historia ya bonasi.',
'multisession_title': 'Vikao vingi haviruhusiwi',
'multisession_message': 'Kikao chako kimesimamishwa kwa sababu akaunti ile ile ilifunguliwa kwenye kichupo au dirisha lingine.',
'session_inactivity_warning': 'Kutokana na kutofanya kazi, kikao chako kinakaribia kuisha.',
'autoplay_confirmation': 'Jumla ya kiasi kwa raundi za mchezo wa kiotomatiki',
'balance_before': 'Salio kabla',
'balance_after': 'Salio baada',

};
langArr.zu = {
'loading': 'Iyalayisha',
'hotkeys': 'Izinkinobho ezisheshayo',
'hotkeys_enabled': 'Izinkinobho ezisheshayo zivuliwe',
'enable_hotkeys_checkbox': 'Vula izinkinobho ezisheshayo eziboniswe ngezansi ngokumaka le bhokisi.',
'make_bet': 'Faka ukubheja',
'double_bet': 'Phinda kabili inani lokubheja',
'halve_bet': 'Yehlisa ukubheja ngengxenye',
'min_bet': 'Inani elincane lokubheja',
'cashout_key': 'Khipha imali',
'walk_next_line': 'Hambela umugqa olandelayo',
'max': 'Okukhulu',
'easy': 'Kulula',
'medium': 'Maphakathi',
'hard': 'Kunzima',
'daredevil': 'Isibindi',
'max_profit': 'Inzuzo enkulu',
'manual': 'Ngokwenza',
'auto': 'Okuzenzakalelayo',
'bet_amount': 'Inani lokubheja',
'difficulty': 'Ubunzima',
'payout_on_win': 'Inkokhelo uma uwina',
'number_of_bets': 'Inani lokubheja',
'on_win': 'Uma uwina',
'on_loss': 'Uma uhlulwa',
'stop_on_profit': 'Yima uma kukhona inzuzo',
'stop_on_loss': 'Yima uma uhlulwa',
'reset': 'Setha kabusha',
'increase_by': 'Khulisa ngo',
'cashout': 'KHIPHA IMALI',
'start_game': 'BHEJA',
'start_auto_game': 'QALA',
'difficulity_info': 'Ulwazi lobunzima',
'chance_collision': 'Amathuba okushayisana ngomdlalo',
'evry_25_lane': 'ngemigqa engama-25',
'insufficient_funds': 'Izimali azanele',
'cashout_inactivity': 'Ukukhipha imali ngenxa yokungasebenzi',
'time_running_out': 'Isikhathi siyaphela! Dlala manje noma ithikithi lakho lizokhanselwa ngokuzenzakalelayo ngemizuzwana engu-30',
'there_was_error': 'KUBE NEPHUTHA SICELA UZAME FUTHI NOMA ULAYISHE KABUSHA',
'detailed_game_rules': 'Imithetho enemininingwane yomdlalo',
'general_rules': 'IMITETHO EJWAYELEKILE',
'general_rules_p1': '• Isiphindaphindi siqala ku-1 bese sikhuphuka siye ku-',
'general_rules_p2': '• Ukuwina kubalwa ngokuphindaphinda ukubheja ngesiphindaphindi esiboniswe esinyathelweni ngasinye.',
'general_rules_p3': '• Uma inkokhelo ephezulu ifinyelelwa, umdlalo uzokhipha imali ngokuzenzakalelayo ngenani eliphezulu.',
'progressive_jackpot': 'I-JACKPOT EQHUBEKA',
'progressive_jackpot_ss': 'Umgwaqo we-jackpot kanye nokuwina okungenzeka',
'progressive_jackpot_p1': '% yokubheja ngakunye inikelwa esikhwameni se-jackpot eqhubekayo.',
'progressive_jackpot_p2': 'I-Jackpot inikezwa ngendlela ye-"Mystery" noma "must-hit-by". Inani le-jackpot ngayinye ye-"must-hit-by" linqunywa ngokushesha ngemva kokuthi i-jackpot yangaphambilini iwiniwe, ngenjini yezinombolo ezingahleliwe bese ligcinwa lifihliwe kudathabheyisi ekude.',
'progressive_jackpot_p3': 'Uma inani le-"must-hit-by" selifinyelelwe, umdlali wokuqala ofaka ukubheja ngemuva kwalokho uzothola ithuba lokuwina i-jackpot. Uphawu lwe-jackpot luzovela emgwaqweni ongahleliwe, futhi i-jackpot iwiniwa uma umdlali efika kulowo mgwaqo. Uma umdlali engafiki ngenxa yokukhipha imali noma ukushayisana, omunye umdlali ongahleliwe uzothola ithuba. Lokhu kuyaqhubeka kuze kube i-jackpot iwiniwe. Umuntu oyedwa kuphela ongawina i-jackpot.',
'progressive_jackpot_p4': 'QAPHELA: Umjikelezo webhonasi awunikeli esikhwameni se-jackpot. Ngesikhathi sebhonasi i-jackpot ayikwazi ukuwinwa.',
'showdown': 'UKUBONISWA',
'showdown_ss': 'Isikwele esibomvu, indawo yokushayisana eqinisekile',
'showdown_p1': 'Ngemva kokuthi umdlali ekhiphe imali, kuzoboniswa isikwele esibomvu endaweni lapho ukushayisana bekuzokwenzeka khona uma umdlali eqhubekile.',
'return_to_player': 'UKUBUYELA KUMDLALI',
'return_to_player_p1': 'Izinga lokubuyela kumdlali (RTP) eliphelele lingu-',
'return_to_player_p2': 'Amaphesenti e-RTP aqhubeka eqashwa futhi aqinisekiswe izinhlangano ezizimele.',
'disconnection_policy': 'INQUBOMGOMO YOKUNQANYULWA',
'disconnection_policy_p1': 'Uma uxhumano lulahlekile ngemva kokubheja, ukubheja ngeke kukhanselwe ngokushesha. Uma ukungasebenzi kufinyelela ',
'disconnection_policy_p2': 'ukubheja kuzokhishwa imali ngokuzenzakalelayo futhi izimali zifakwe ku-akhawunti yomdlali.',
'network_latency': 'UKUBAMBEZELEKA KWENETHIWEKHI',
'network_latency_p1': 'Ukubambezeleka kwenethiwekhi kuyinto engavinjelwa ku-inthanethi. Sibheka ukubheja nokukhipha imali njengokuvumelekile kuphela uma kufinyelela kuseva yethu.',
'sound': 'UMSINDO',
'sound_p1': 'Umdlalo wakhelwe ngomculo ongemuva omuhle nemisindo. Uma ufuna ukuwucisha, ungakwenza ngezithonjana zemenyu yomdlalo.',
'error_handling': 'UKUPHATHWA KWAMAPHUTHA',
'error_handling_p1': 'Uma kuba nephutha ithimba lethu losekelo lizozama ukulilungisa ngokushesha. Uma kunenkinga ngomdlalo uqobo, konke ukubheja kuzokhanselwa futhi izimali zibuyiselwe.',
'max_payout': 'Inkokhelo ephezulu ingu-',
'max_bet_is': 'Ukubheja okuphezulu ngu-',
'min_bet_is': 'Ukubheja okuncane ngu-',
'per_bet': 'ngokubheja ngakunye.',
'malfunction_voids': 'Ukungasebenzi kwenza zonke izinkokhelo nemidlalo zingasebenzi.',
'attention_jackpot': 'QAPHELA, i-jackpot isemgwaqweni ',
'lane': 'umgwaqo',
'congratulations': 'siyakuhalalisela',
'you_won': 'uwinile',
'balance': 'ibhalansi',
'time': 'isikhathi',
'jackpot': 'i-jackpot',
'escaped': 'UPHUMELELE',
'max_win': 'UKUWINIWA OKUPHEZULU',
'check_internet': 'Sicela uhlole uxhumano lwakho lwe-inthanethi',
'websocket_disconected': 'I-Websocket inqanyuliwe',
'websocket_connection_error': 'Iphutha lokuxhuma i-Websocket!',
'session_expired': 'Iseshini iphelile sicela ulayishe kabusha',
'remaining_bets': 'Ukubheja okusele',
'stop_autoplay': 'YIMA',
'autoplay_and_autocashout': 'UKUDLALA NGOKUZENZAKALELAYO NOKUKHIPHA IMALI',
'autoplay_and_autocashout_ss': 'Ukukhetha phakathi kokwenza nokuzisebenzela',
'autoplay_and_autocashout_p1': 'Umdlali angavula ukudlala ngokuzenzakalelayo lapho ukubheja kufakwa ngokuzenzakalelayo kuwo wonke umjikelezo omusha.',
'autoplay_and_autocashout_p2': 'Isiphindaphindi sokukhipha imali ngokuzenzakalelayo singakhethwa, futhi umdlalo uzokhipha imali uma singashayi ngaphambi kokufinyelela kuleso siphindaphindi.',
'autoplay_and_autocashout_p3': 'Inani eliphezulu lemijikelezo yokudlala ngokuzenzakalelayo lingu-',
'autoplay_button_label': 'Ukuqala, khetha umgwaqo.',
'min_bet_amount_is': 'Inani elincane lokubheja lingu',
'bonus_rounds': 'imizuliswano yebhonasi',
'bonus_rounds_ss': 'Imizuliswano yebhonasi enesikhathi sokusebenza',
'bonus_rounds_p1': 'Umdlali anganikezwa umjikelezo webhonasi ngokuya ngesikhangiso sekhasino.',
'bonus_rounds_p2': 'Uma isinikiwe, umdlali angakhetha ukuthi aqale nini. Uma iqala, ukubheja okuzenzakalelayo kufakwa.',
'bonus_rounds_p3': 'Imizuliswano yebhonasi ingaba nesikhathi sokuphelelwa, ngemva kwalokho ayisebenzi.',
'bonus_rounds_p4': 'Ukungasebenzi komdlali kungaholela ekukhanselweni komjikelezo webhonasi osebenzayo.',
'valid_until': 'isebenza kuze kube',
'bonus': 'ibhonasi',
'rounds': 'imizuliswano',
'win_eur': 'uwine i-EUR',
'complete_your_bet': 'Sicela uqedele ukubheja kwakho kuqala',
'complete_auto_play': 'Sicela uqedele ukudlala okuzenzakalelayo kuqala',
'yes': 'yebo',
'no': 'cha',
'play_bonus_rounds': 'Dlala imizuliswano yebhonasi?',
'bet_history': 'Umlando wokubheja',
'jackpot_history': 'Umlando we-jackpot',
'ticket_id': 'I-ID yethikithi',
'created': 'isikhathi sokwakhiwa',
'currency': 'imali',
'bet': 'ukubheja',
'bet_eur': 'ukubheja i-EUR',
'lanes': 'imigwaqo',
'cars': 'izimoto',
'multiplier': 'isiphindaphindi',
'win': 'uwine',
'no_betting_history': 'Awukho umlando wokubheja otholakele.',
'no_jackpot_history': 'Awukho umlando we-jackpot otholakalayo.',
'date': 'usuku',
'user': 'umsebenzisi',
'bet_already_active': 'Ukubheja sekuvele kusebenzile',
'please_play_the_game_in_portait_mode': 'Sicela udlale umdlalo ngesimo se-portrait.',
'bonus_history': 'Umlando webhonasi',
'bonus_type': 'Uhlobo lwebhonasi',
'no_bonus_history': 'Awukho umlando webhonasi otholakalayo.',
'game_menu': 'Imenyu yomdlalo',
'game_menu_ss': 'Kusuka kwesobunxele: Ikhaya, Umlando wokubheja, Imithetho yomdlalo, Izinqamuleli zekhibhodi, Izilungiselelo zomsindo, Umculo',
'game_menu_p1': 'Ngemenyu yomdlalo, abadlali bangalawula umsindo, izinqamuleli zekhibhodi, futhi bavule umlando nomthetho womdlalo.',
'game_menu_p2': 'Umlando womdlalo uzobonisa amawindi okubheja kwangaphambilini nomlando webhonasi.',
'multisession_title': 'Amavilakazikhombisi amaningi akavunyelwe',
'multisession_message': 'Uhlelo lwakho luwaliwe ngoba i-akhawunti efanayo yavulwa kwenye i-tab noma ifasitela.',
'session_inactivity_warning': 'Ngenxa yokungasebenzi, iseshini yakho isizophela.',
'autoplay_confirmation': 'Inani eliphelele lemijikelezo yokudlala ngokuzenzakalelayo',
'balance_before': 'Ibhalansi ngaphambi',
'balance_after': 'Ibhalansi emva',

};
langArr.xh = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Iiseshoni ezininzi azivunyelwanga',
'multisession_message': 'Iseshoni yakho iphelisiwe kuba i-akhawunti efanayo yavulwa kwenye itab okanye ifestile.',
'session_inactivity_warning': 'Ngenxa yokungasebenzi, iseshoni yakho isizophela.',
'autoplay_confirmation': 'Iimali ezipheleleyo zemijikelezo yokudlala ngokuzenzekelayo',
'balance_before': 'Ibhalansi ngaphambi',
'balance_after': 'Ibhalansi emva',

};
langArr.af = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Veelvoudige sessies is nie toegelaat nie',
'multisession_message': 'Jou sessie is beëindig omdat dieselfde rekening in \'n ander oortjie of venster oopgemaak is.',
'session_inactivity_warning': 'As gevolg van inaktiwiteit, sal jou sessie verval.',
'autoplay_confirmation': 'Totale bedrag vir outospeel rondtes',
'balance_before': 'Balans voor',
'balance_after': 'Balans ná',

};
langArr.so = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Fadhiyeyaasha badan lama ogola',
'multisession_message': 'Fadhigaaga waa la joojiyay sababtoo ah xisaabta isku mid ah ayaa laga furay tab kale ama daaqad kale.',
'session_inactivity_warning': 'Sababo la xiriira hawl la’aan, fadhigaaga wuu dhamaan doonaa.',
'autoplay_confirmation': 'Wadarta lacagta ee wareegyada ciyaarta otomaatigga',
'balance_before': 'Haraaga ka hor',
'balance_after': 'Haraaga ka dib',

};
langArr.tn = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Dikopano tse dintsi ga di letelelwe',
'multisession_message': 'Kopano ya gago e kgaotswe ka gonne akhaonto e tshwanang e bulegilwe mo tepeng kgotsa fenestere e nngwe.',
'session_inactivity_warning': 'Ka ntlha ya go se dirise, kopano ya gago e tla fela.',
'autoplay_confirmation': 'Palo yotlhe ya dikgaisano tsa go itshameka ka go itirisa',
'balance_before': 'Boleng pele',
'balance_after': 'Boleng morago',

};
langArr.ar = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'الجلسات المتعددة غير مسموح بها',
'multisession_message': 'تم إنهاء جلستك لأن نفس الحساب تم فتحه في علامة تبويب أو نافذة أخرى.',
'session_inactivity_warning': 'بسبب عدم النشاط، ستنتهي جلستك.',
'autoplay_confirmation': 'المبلغ الإجمالي لجولات اللعب التلقائي',
'balance_before': 'الرصيد قبل',
'balance_after': 'الرصيد بعد',

};
langArr.bg = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Множество сесии не са разрешени',
'multisession_message': 'Вашата сесия е прекратена, тъй като същият акаунт е отворен в друг раздел или прозорец.',
'session_inactivity_warning': 'Поради бездействие вашата сесия ще изтече.',
'autoplay_confirmation': 'Обща сума за рундове на автоплей',
'balance_before': 'Баланс преди',
'balance_after': 'Баланс след',

};
langArr.de = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Mehrfachsitzungen sind nicht erlaubt',
'multisession_message': 'Ihre Sitzung wurde beendet, da dasselbe Konto in einem anderen Tab oder Fenster geöffnet wurde.',
'session_inactivity_warning': 'Aufgrund von Inaktivität wird Ihre Sitzung ablaufen.',
'autoplay_confirmation': 'Gesamtbetrag für Autoplay-Runden',
'balance_before': 'Kontostand vor',
'balance_after': 'Kontostand nach',

};
langArr.el = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Πολλαπλές συνεδρίες δεν επιτρέπονται',
'multisession_message': 'Η συνεδρία σας τερματίστηκε επειδή ο ίδιος λογαριασμός ανοίχθηκε σε άλλη καρτέλα ή παράθυρο.',
'session_inactivity_warning': 'Λόγω αδράνειας, η συνεδρία σας θα λήξει.',
'autoplay_confirmation': 'Συνολικό ποσό για γύρους αυτόματου παιχνιδιού',
'balance_before': 'Υπόλοιπο πριν',
'balance_after': 'Υπόλοιπο μετά',

};
langArr.es = {
'loading': 'Cargando',
'hotkeys': 'Atajos de teclado',
'hotkeys_enabled': 'Atajos de teclado habilitados',
'enable_hotkeys_checkbox': 'Active los atajos de teclado mostrados a continuación marcando esta casilla.',
'make_bet': 'Hacer una apuesta',
'double_bet': 'Duplicar la apuesta',
'halve_bet': 'Reducir la apuesta a la mitad',
'min_bet': 'Apuesta mínima',
'cashout_key': 'Cobrar',
'walk_next_line': 'Caminar a la siguiente línea',
'max': 'Máx',
'easy': 'Fácil',
'medium': 'Medio',
'hard': 'Difícil',
'daredevil': 'Temerario',
'max_profit': 'Ganancia máxima',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Monto de la apuesta',
'difficulty': 'Dificultad',
'payout_on_win': 'Pago al ganar',
'number_of_bets': 'Número de apuestas',
'on_win': 'Al ganar',
'on_loss': 'Al perder',
'stop_on_profit': 'Detener con ganancia',
'stop_on_loss': 'Detener con pérdida',
'reset': 'Reiniciar',
'increase_by': 'Incrementar en',
'cashout': 'COBRAR',
'start_game': 'APOSTAR',
'start_auto_game': 'INICIAR',
'difficulity_info': 'Información de dificultad',
'chance_collision': 'Probabilidad de colisión por juego',
'evry_25_lane': 'por cada 25 carriles',
'insufficient_funds': 'Fondos insuficientes',
'cashout_inactivity': 'Cobro parcial por inactividad',
'time_running_out': '¡El tiempo se acaba! Juega ahora o tu boleto será retirado automáticamente en 30 segundos',
'there_was_error': 'HUBO UN ERROR, POR FAVOR INTENTA DE NUEVO O RECARGA',
'detailed_game_rules': 'Reglas detalladas del juego',
'general_rules': 'REGLAS GENERALES',
'general_rules_p1': '• El multiplicador comienza en 1 y sube hasta ',
'general_rules_p2': '• Las ganancias se calculan multiplicando la apuesta por el multiplicador mostrado en cada paso.',
'general_rules_p3': '• Si se alcanza el pago máximo, el juego cobrará automáticamente ese monto máximo.',
'progressive_jackpot': 'JACKPOT PROGRESIVO',
'progressive_jackpot_ss': 'El carril del jackpot y la posible ganancia',
'progressive_jackpot_p1': '% de cada apuesta se destina a un fondo de jackpot progresivo.',
'progressive_jackpot_p2': 'El jackpot se otorga mediante una mecánica de "Misterio" o "debe-caer". El valor de cada jackpot "debe-caer" se determina inmediatamente después de que el anterior sea ganado, mediante un generador de números aleatorios y se almacena cifrado en la base de datos remota. El valor está cifrado y oculto, y no es conocido.',
'progressive_jackpot_p3': 'Una vez alcanzado el valor "debe-caer", el primer jugador que apueste después tendrá la oportunidad de ganar el jackpot. Un símbolo de jackpot aparecerá en un carril aleatorio, y el jackpot se gana si el jugador llega a ese carril. Si el jugador no llega al carril por cobrar antes o por chocar, el siguiente jugador verá el símbolo y tendrá la oportunidad de ganar. El proceso se repite hasta que alguien gana. Solo un jugador puede ganar el jackpot.',
'progressive_jackpot_p4': 'NOTA: La ronda de bonificación no contribuye al fondo del jackpot. Durante la ronda de bonificación no se puede ganar el jackpot.',
'showdown': 'ENFRENTAMIENTO',
'showdown_ss': 'Cuadro rojo, ubicación de colisión segura',
'showdown_p1': 'Después de cobrar, se mostrará un cuadro rojo en el lugar donde habría ocurrido la colisión si el jugador hubiese continuado.',
'return_to_player': 'RENTABILIDAD AL JUGADOR (RTP)',
'return_to_player_p1': 'La rentabilidad teórica general al jugador es ',
'return_to_player_p2': 'Los porcentajes de RTP son monitoreados y verificados por terceros independientes.',
'disconnection_policy': 'POLÍTICA DE DESCONEXIÓN',
'disconnection_policy_p1': 'Si se pierde la conexión después de hacer una apuesta, esta no se cancelará inmediatamente. Si la inactividad alcanza ',
'disconnection_policy_p2': 'la apuesta será cobrada automáticamente y los créditos se aplicarán a la cuenta del jugador.',
'network_latency': 'LATENCIA DE RED',
'network_latency_p1': 'La latencia de red es una parte inevitable de la conectividad a Internet. Consideramos válidas todas las apuestas y cobros solo en el momento en que llegan a nuestro servidor, sin importar la duración de la latencia.',
'sound': 'SONIDO',
'sound_p1': 'El juego está diseñado con música de fondo y efectos de sonido. Si deseas desactivar música o efectos, puedes hacerlo desde el menú del juego.',
'error_handling': 'MANEJO DE ERRORES',
'error_handling_p1': 'En caso de error, nuestro equipo de soporte intentará resolverlo lo antes posible y reanudar el juego. Si el problema es con el juego en sí, todas las apuestas serán canceladas y se devolverán las cantidades apostadas.',
'max_payout': 'El pago máximo es ',
'max_bet_is': 'La apuesta máxima es ',
'min_bet_is': 'La apuesta mínima es ',
'per_bet': 'por apuesta.',
'malfunction_voids': 'El mal funcionamiento anula todos los pagos y jugadas.',
'attention_jackpot': 'Atención, Jackpot en el carril ',
'lane': 'carril',
'congratulations': 'felicitaciones',
'you_won': 'has ganado',
'balance': 'saldo',
'time': 'tiempo',
'jackpot': 'jackpot',
'escaped': 'ESCAPADO',
'max_win': 'GANANCIA MÁXIMA',
'check_internet': 'Por favor, verifica tu conexión a internet',
'websocket_disconected': 'Websocket desconectado',
'websocket_connection_error': '¡Error de conexión con Websocket!',
'session_expired': 'La sesión ha expirado, por favor recarga',
'remaining_bets': 'Apuestas restantes',
'stop_autoplay': 'DETENER',
'autoplay_and_autocashout': 'JUEGO AUTOMÁTICO Y COBRO AUTOMÁTICO',
'autoplay_and_autocashout_ss': 'Selección entre manual y automático',
'autoplay_and_autocashout_p1': 'El jugador puede activar la opción de juego automático, donde se coloca automáticamente una apuesta en cada ronda usando el mismo monto de la apuesta anterior.',
'autoplay_and_autocashout_p2': 'Se puede seleccionar un multiplicador de cobro automático en la pantalla, y cuando se alcance, el juego cobrará automáticamente si el jugador no choca antes.',
'autoplay_and_autocashout_p3': 'El número máximo de rondas automáticas es ',
'autoplay_button_label': 'Para comenzar, elige un carril.',
'min_bet_amount_is': 'La apuesta mínima es',
'bonus_rounds': 'rondas de bonificación',
'bonus_rounds_ss': 'Las rondas de bonificación con período de validez',
'bonus_rounds_p1': 'El jugador puede recibir rondas de bonificación (apuestas gratis) como parte de una promoción. Aparecerá un aviso en pantalla indicando el número de rondas, el monto y la validez.',
'bonus_rounds_p2': 'El jugador puede elegir cuándo iniciar la ronda de bonificación. Una vez iniciada, se hace automáticamente la apuesta con el monto indicado y el jugador decide cuándo cobrar.',
'bonus_rounds_p3': 'Las rondas de bonificación pueden tener un límite de tiempo, después del cual caducan.',
'bonus_rounds_p4': 'La inactividad del jugador puede provocar la cancelación de una ronda de bonificación activa. En este caso, se reduce el número de rondas, pero el saldo del jugador permanece igual.',
'valid_until': 'válido hasta',
'bonus': 'bono',
'rounds': 'rondas',
'win_eur': 'ganancia EUR',
'complete_your_bet': 'Por favor completa tu apuesta primero',
'complete_auto_play': 'Por favor completa tu juego automático primero',
'yes': 'sí',
'no': 'no',
'play_bonus_rounds': '¿Jugar rondas de bonificación?',
'bet_history': 'Historial de apuestas',
'jackpot_history': 'Historial de jackpots',
'ticket_id': 'ID del boleto',
'created': 'fecha de creación',
'currency': 'moneda',
'bet': 'apuesta',
'bet_eur': 'apuesta EUR',
'lanes': 'carriles',
'cars': 'coches',
'multiplier': 'multiplicador',
'win': 'ganancia',
'no_betting_history': 'No se encontró historial de apuestas. Haz una apuesta y aparecerá aquí.',
'no_jackpot_history': 'No hay historial de jackpots disponible.',
'date': 'fecha',
'user': 'usuario',
'bet_already_active': 'La apuesta ya está activa',
'please_play_the_game_in_portait_mode': 'Por favor, juega en modo vertical.',
'bonus_history': 'Historial de bonificación',
'bonus_type': 'Tipo de bonificación',
'no_bonus_history': 'No hay historial de bonificaciones disponible.',
'game_menu': 'Menú del juego',
'game_menu_ss': 'De izquierda a derecha: Inicio, Historial de apuestas, Reglas del juego, Atajos de teclado, Configuración de sonido, Música',
'game_menu_p1': 'A través del menú, los jugadores pueden controlar las opciones de sonido, atajos de teclado y abrir historial y reglas.',
'game_menu_p2': 'El historial mostrará apuestas previas y bonificaciones.',
'multisession_title': 'No se permiten múltiples sesiones',
'multisession_message': 'Su sesión ha sido terminada porque la misma cuenta fue abierta en otra pestaña o ventana.',
'session_inactivity_warning': 'Debido a inactividad, su sesión expirará.',
'autoplay_confirmation': 'Importe total para rondas de juego automático',
'balance_before': 'Saldo antes',
'balance_after': 'Saldo después',

};
langArr.fr = {
'loading': 'Chargement',
'hotkeys': 'Raccourcis clavier',
'hotkeys_enabled': 'Raccourcis clavier activés',
'enable_hotkeys_checkbox': 'Activez les raccourcis clavier ci-dessous en cochant cette case.',
'make_bet': 'Faire un pari',
'double_bet': 'Doubler un montant de pari',
'halve_bet': 'Diviser un montant de pari par deux',
'min_bet': 'Montant minimum du pari',
'cashout_key': 'Encaisser',
'walk_next_line': 'Avancer à la ligne suivante',
'max': 'Max',
'easy': 'Facile',
'medium': 'Moyen',
'hard': 'Difficile',
'daredevil': 'Casse-cou',
'max_profit': 'Profit maximal',
'manual': 'Manuel',
'auto': 'Auto',
'bet_amount': 'Montant du pari',
'difficulty': 'Difficulté',
'payout_on_win': 'Gain en cas de victoire',
'number_of_bets': 'Nombre de paris',
'on_win': 'En cas de victoire',
'on_loss': 'En cas de perte',
'stop_on_profit': 'Arrêter en cas de profit',
'stop_on_loss': 'Arrêter en cas de perte',
'reset': 'Réinitialiser',
'increase_by': 'Augmenter de',
'cashout': 'ENCACHER',
'start_game': 'PARIER',
'start_auto_game': 'DÉMARRER',
'difficulity_info': 'Infos sur la difficulté',
'chance_collision': 'Chance de collision par jeu',
'evry_25_lane': 'Tous les 25 parcours',
'insufficient_funds': 'Fonds insuffisants',
'cashout_inactivity': 'Encaissement en cas d\'inactivité',
'time_running_out': 'Le temps est presque écoulé ! Jouez maintenant ou votre ticket sera retiré automatiquement dans 30 secondes',
'there_was_error': 'IL Y A EU UNE ERREUR, VEUILLEZ ESSAYER À NOUVEAU OU RECHARGER',
'detailed_game_rules': 'Règles du jeu détaillées',
'general_rules': 'RÈGLES GÉNÉRALES',
'general_rules_p1': '• Le multiplicateur commence à 1 et monte jusqu\'à',
'general_rules_p2': '• Les gains sont calculés en multipliant le montant du pari par le multiplicateur affiché à chaque étape.',
'general_rules_p3': '• Si le paiement maximum est atteint, le jeu encaissera automatiquement au montant du paiement maximum.',
'progressive_jackpot': 'JACKPOT PROGRESSIF',
'progressive_jackpot_ss': 'Le parcours du jackpot et le gain possible',
'progressive_jackpot_p1': '% de chaque mise est dédié à un fonds de jackpot progressif.',
'progressive_jackpot_p2': 'Le jackpot est attribué en utilisant une mécanique "Mystery" ou "must-hit-by". La valeur de chaque jackpot "must-hit-by" est déterminée immédiatement après qu\'un jackpot précédent a été gagné par un générateur de nombres aléatoires et stockée comme une valeur cryptée dans la base de données distante. La valeur est cryptée et donc cachée et n\'est pas connue.',
'progressive_jackpot_p3': 'Une fois que la valeur "must-hit-by" est atteinte, le premier joueur à parier après cette valeur aura la chance de gagner le jackpot. Un symbole de jackpot apparaîtra sur un parcours aléatoire, et le jackpot sera gagné si le joueur atteint le parcours avec le symbole. Si le joueur ne parvient pas à atteindre le parcours avec le symbole du jackpot en encaissant ou en s\'écrasant, le prochain joueur aléatoire à parier verra apparaître le symbole du jackpot et aura la chance de gagner. Ce processus se répète jusqu\'à ce que le jackpot soit gagné. Un seul ticket/joueur peut gagner le jackpot.',
'progressive_jackpot_p4': 'NOTE : Le tour bonus ne contribue pas au fonds du jackpot. Pendant le tour bonus, le jackpot ne peut pas être gagné.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Carré rouge, emplacement de la collision certaine',
'showdown_p1': 'Après que le joueur ait encaissé, un carré rouge sera affiché à l\'emplacement où la collision se serait produite si le joueur avait continué à sauter les parcours.',
'return_to_player': 'RETOUR AU JOUEUR',
'return_to_player_p1': 'Le retour théorique au joueur (RTP) global est de',
'return_to_player_p2': 'Les pourcentages RTP sont continuellement surveillés et vérifiés par des tiers indépendants.',
'disconnection_policy': 'POLITIQUE DE DÉCONNEXION',
'disconnection_policy_p1': 'Si la connexion est perdue après qu\'un pari ait été placé, le pari ne sera pas annulé immédiatement. Si l\'inactivité du joueur atteint',
'disconnection_policy_p2': 'le pari sera automatiquement encaissé et les crédits seront appliqués au compte du joueur.',
'network_latency': 'LATENCE RÉSEAU',
'network_latency_p1': 'La latence réseau fait partie intégrante de la connectivité Internet. Nous considérons tous les paris et encaissements comme valides uniquement au moment où ils atteignent notre serveur, quelle que soit la durée de la latence réseau.',
'sound': 'SON',
'sound_p1': 'Le jeu est conçu avec une belle musique de fond et des effets sonores. Si vous souhaitez désactiver la musique et/ou les effets sonores, vous pouvez le faire via les icônes du menu du jeu.',
'error_handling': 'GESTION DES ERREURS',
'error_handling_p1': 'En cas d\'erreur, notre équipe d\'assistance tentera de résoudre le problème dès que possible et de reprendre le jeu normalement. En cas de problème avec le jeu lui-même, tous les paris seront annulés et le montant du pari sera retourné aux joueurs.',
'max_payout': 'Le paiement maximum est de',
'max_bet_is': 'Le pari maximum est de',
'min_bet_is': 'Le pari minimum est de',
'per_bet': 'par pari.',
'malfunction_voids': 'Le dysfonctionnement annule tous les paiements et jeux.',
'attention_jackpot': 'Attention, jackpot sur le parcours',
'lane': 'parcours',
'congratulations': 'félicitations',
'you_won': 'vous avez gagné',
'balance': 'solde',
'time': 'temps',
'jackpot': 'jackpot',
'escaped': 'ÉCHAPPÉ',
'max_win': 'GAGNE MAXIMAL',
'check_internet': 'Veuillez vérifier votre connexion Internet',
'websocket_disconected': 'Websocket déconnecté',
'websocket_connection_error': 'Erreur de connexion Websocket !',
'session_expired': 'Session expirée, veuillez recharger',
'remaining_bets': 'Paris restants',
'stop_autoplay': 'ARRÊTER',
'autoplay_and_autocashout': 'AUTOPLAY ET AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Sélection entre manuel et autoplay',
'autoplay_and_autocashout_p1': 'Un joueur peut activer l\'option autoplay où un pari est automatiquement placé pour chaque nouveau tour en utilisant le montant du pari du tour précédent.',
'autoplay_and_autocashout_p2': 'Un multiplicateur d\'encaissement automatique peut être sélectionné depuis l\'écran du jeu, et une fois défini, le jeu encaissera automatiquement si le joueur n\'est pas touché avant d\'atteindre le multiplicateur sélectionné.',
'autoplay_and_autocashout_p3': 'Le nombre maximum de tours autoplay est de',
'autoplay_button_label': 'Pour commencer, choisissez un parcours.',
'min_bet_amount_is': 'Le montant minimum du pari est',
'bonus_rounds': 'Tours bonus',
'bonus_rounds_ss': 'Les tours bonus avec période de validité',
'bonus_rounds_p1': 'Un joueur peut recevoir un tour bonus (c\'est-à-dire un pari gratuit) en fonction d\'une promotion du casino. Un graphique popup apparaîtra à l\'écran pour informer le joueur des tours bonus attribués, du nombre de paris, du montant par pari et éventuellement de la période de validité.',
'bonus_rounds_p2': 'Une fois attribués, le joueur peut choisir quand commencer le tour bonus. Une fois le tour bonus commencé, un pari automatique avec la mise spécifiée est placé, et il appartient au joueur d\'encaisser à tout moment.',
'bonus_rounds_p3': 'Les tours bonus peuvent avoir une limite de temps, après laquelle ils deviennent caducs et inutilisables. La période de validité, si elle existe, est affichée sous le tour bonus.',
'bonus_rounds_p4': 'L\'inactivité du joueur peut entraîner l\'annulation d\'un tour bonus actif. Dans ce cas, le nombre de tours bonus est réduit et le solde du joueur reste le même.',
'valid_until': 'valide jusqu\'à',
'bonus': 'bonus',
'rounds': 'tours',
'win_eur': 'gagner EUR',
'complete_your_bet': 'Veuillez d\'abord compléter votre pari',
'complete_auto_play': 'Veuillez d\'abord compléter votre autoplay',
'yes': 'oui',
'no': 'non',
'play_bonus_rounds': 'Jouer aux tours bonus ?',
'bet_history': 'Historique des paris',
'jackpot_history': 'Historique des jackpots',
'ticket_id': 'ID du ticket',
'created': 'heure de création',
'currency': 'monnaie',
'bet': 'pari',
'bet_eur': 'pari EUR',
'lanes': 'parcours',
'cars': 'voitures',
'multiplier': 'multiplicateur',
'win': 'gain',
'no_betting_history': 'Aucun historique de paris trouvé. Faites un pari, il apparaîtra ici.',
'no_jackpot_history': 'Aucun historique de jackpot disponible.',
'date': 'date',
'user': 'utilisateur',
'bet_already_active': 'Le pari est déjà actif',
'please_play_the_game_in_portait_mode': 'Veuillez jouer en mode portrait.',
'bonus_history': 'Historique des bonus',
'bonus_type': 'Type de bonus',
'no_bonus_history': 'Aucun historique de bonus disponible.',
'game_menu': 'Menu du jeu',
'game_menu_ss': 'De gauche à droite : Accueil, Historique des paris, Règles du jeu, Raccourcis clavier, Paramètres des effets sonores, Musique',
'game_menu_p1': 'Grâce au menu du jeu, les joueurs peuvent contrôler les options de son, les raccourcis clavier, ainsi qu\'ouvrir l\'historique du jeu et les règles du jeu.',
'game_menu_p2': 'L\'historique du jeu affichera une fenêtre avec les paris précédents et l\'historique des bonus.',
'multisession_title': 'Les sessions multiples ne sont pas autorisées',
'multisession_message': 'Votre session a été terminée car le même compte a été ouvert dans un autre onglet ou fenêtre.',
'session_inactivity_warning': 'En raison de l\'inactivité, votre session expirera.',
'autoplay_confirmation': 'Montant total pour les tours de jeu automatique',
'balance_before': 'Solde avant',
'balance_after': 'Solde après',

};
langArr.he = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'ריבוי הפעלות אינו מותר',
'multisession_message': 'ההפעלה שלך הסתיימה מכיוון שאותו חשבון נפתח בכרטיסייה או בחלון אחר.',
'session_inactivity_warning': 'עקב חוסר פעילות, ההפעלה שלך תסתיים.',
'autoplay_confirmation': 'סכום כולל לסבבי משחק אוטומטי',
'balance_before': 'יתרה לפני',
'balance_after': 'יתרה אחרי',

};
langArr.hr = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Višestruke sesije nisu dopuštene',
'multisession_message': 'Vaša sesija je prekinuta jer je isti račun otvoren u drugoj kartici ili prozoru.',
'session_inactivity_warning': 'Zbog neaktivnosti, vaša sesija će isteći.',
'autoplay_confirmation': 'Ukupan iznos za autoplay runde',
'balance_before': 'Stanje prije',
'balance_after': 'Stanje poslije',

};
langArr.hu = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Többszörös munkamenet nem engedélyezett',
'multisession_message': 'A munkamenete megszakadt, mert ugyanazt a fiókot egy másik lapon vagy ablakban nyitották meg.',
'session_inactivity_warning': 'Inaktivitás miatt a munkamenet lejár.',
'autoplay_confirmation': 'Teljes összeg az automata játék körökhöz',
'balance_before': 'Egyenleg előtte',
'balance_after': 'Egyenleg utána',

};
langArr.it = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Le sessioni multiple non sono consentite',
'multisession_message': 'La tua sessione è stata terminata perché lo stesso account è stato aperto in un\'altra scheda o finestra.',
'session_inactivity_warning': 'A causa dell\'inattività, la tua sessione scadrà.',
'autoplay_confirmation': 'Importo totale per i round di gioco automatico',
'balance_before': 'Saldo prima',
'balance_after': 'Saldo dopo',

};
langArr.mk = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Повеќекратните сесии не се дозволени',
'multisession_message': 'Вашата сесија е прекината бидејќи истата сметка е отворена во друга картичка или прозорец.',
'session_inactivity_warning': 'Поради неактивност, вашата сесија ќе истече.',
'autoplay_confirmation': 'Вкупен износ за рунди на автоигра',
'balance_before': 'Салдо пред',
'balance_after': 'Салдо по',

};
langArr.pl = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Wielokrotne sesje nie są dozwolone',
'multisession_message': 'Twoja sesja została zakończona, ponieważ to samo konto zostało otwarte w innej karcie lub oknie.',
'session_inactivity_warning': 'Z powodu bezczynności Twoja sesja wygaśnie.',
'autoplay_confirmation': 'Łączna kwota na rundy autoplay',
'balance_before': 'Saldo przed',
'balance_after': 'Saldo po',

};
langArr.pt = {
'loading': 'Carregando',
'hotkeys': 'Atalhos',
'hotkeys_enabled': 'Atalhos Ativados',
'enable_hotkeys_checkbox': 'Ative os atalhos mostrados abaixo marcando esta caixa.',
'make_bet': 'Fazer aposta',
'double_bet': 'Dobrar aposta',
'halve_bet': 'Reduzir aposta pela metade',
'min_bet': 'Aposta mínima',
'cashout_key': 'Sacar',
'walk_next_line': 'Andar para a próxima linha',
'max': 'Máximo',
'easy': 'Fácil',
'medium': 'Médio',
'hard': 'Difícil',
'daredevil': 'Corajoso',
'max_profit': 'Lucro Máximo',
'manual': 'Manual',
'auto': 'Automático',
'bet_amount': 'Valor da aposta',
'difficulty': 'Dificuldade',
'payout_on_win': 'Pagamento na vitória',
'number_of_bets': 'Número de apostas',
'on_win': 'Ao ganhar',
'on_loss': 'Ao perder',
'stop_on_profit': 'Parar no lucro',
'stop_on_loss': 'Parar na perda',
'reset': 'Redefinir',
'increase_by': 'Aumentar em',
'cashout': 'SACAR',
'start_game': 'APOSTAR',
'start_auto_game': 'COMEÇAR',
'difficulity_info': 'Informações de dificuldade',
'chance_collision': 'Chance de colisão por jogo',
'evry_25_lane': 'a cada 25 pistas',
'insufficient_funds': 'Fundos insuficientes',
'cashout_inactivity': 'Saque automático por inatividade',
'time_running_out': 'O tempo está acabando! Jogue agora ou seu bilhete será retirado em 30 segundos',
'there_was_error': 'HOUVE UM ERRO, TENTE NOVAMENTE OU RECARREGUE',
'detailed_game_rules': 'Regras Detalhadas do Jogo',
'general_rules': 'REGRAS GERAIS',
'general_rules_p1': '• O multiplicador começa em 1 e vai até ',
'general_rules_p2': '• Os ganhos são calculados multiplicando o valor apostado pelo multiplicador exibido a cada etapa.',
'general_rules_p3': '• Se o pagamento máximo for atingido, o jogo sacará automaticamente nesse valor.',
'progressive_jackpot': 'JACKPOT PROGRESSIVO',
'progressive_jackpot_ss': 'A pista do jackpot e o prêmio possível',
'progressive_jackpot_p1': '% de cada aposta é destinada a um fundo de jackpot progressivo.',
'progressive_jackpot_p2': 'O jackpot é concedido usando uma mecânica "Mystery" ou "must-hit-by". O valor de cada jackpot "must-hit-by" é definido imediatamente após o anterior ser ganho, gerado aleatoriamente e armazenado de forma criptografada no banco de dados remoto.',
'progressive_jackpot_p3': 'Assim que o valor "must-hit-by" for alcançado, o primeiro jogador a apostar terá a chance de ganhar o jackpot. Um símbolo de jackpot aparecerá em uma pista aleatória, e o jogador ganha se alcançar essa pista. Caso saque ou perca antes, o próximo jogador verá o símbolo e terá a chance de ganhar. Esse processo se repete até alguém vencer. Apenas um bilhete/jogador pode ganhar o jackpot.',
'progressive_jackpot_p4': 'NOTA: Rodadas bônus não contribuem para o fundo de jackpot. Durante elas, o jackpot não pode ser ganho.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Quadrado vermelho, localização de colisão certa',
'showdown_p1': 'Depois de sacar, um quadrado vermelho mostrará onde a colisão teria ocorrido se o jogador continuasse.',
'return_to_player': 'RETORNO AO JOGADOR',
'return_to_player_p1': 'O retorno teórico geral ao jogador (RTP) é ',
'return_to_player_p2': 'Os percentuais de RTP são monitorados e verificados por terceiros independentes.',
'disconnection_policy': 'POLÍTICA DE DESCONECTAR',
'disconnection_policy_p1': 'Se a conexão cair após a aposta, ela não será cancelada imediatamente. Se a inatividade durar ',
'disconnection_policy_p2': 'a aposta será sacada automaticamente e o crédito aplicado na conta do jogador.',
'network_latency': 'LATÊNCIA DE REDE',
'network_latency_p1': 'A latência de rede é inevitável. Todas as apostas e saques são válidos apenas quando chegam ao nosso servidor.',
'sound': 'SOM',
'sound_p1': 'O jogo tem música de fundo e efeitos sonoros. Se quiser, é possível desativá-los pelo menu.',
'error_handling': 'TRATAMENTO DE ERROS',
'error_handling_p1': 'Em caso de erro, nosso suporte tentará resolver rapidamente. Se o problema for no jogo, as apostas são canceladas e os valores devolvidos.',
'max_payout': 'Pagamento máximo é ',
'max_bet_is': 'Aposta máxima é ',
'min_bet_is': 'Aposta mínima é ',
'per_bet': 'por aposta.',
'malfunction_voids': 'Falhas anulam todos os Pagamentos e Jogadas.',
'attention_jackpot': 'Atenção, Jackpot na pista ',
'lane': 'pista',
'congratulations': 'parabéns',
'you_won': 'você ganhou',
'balance': 'saldo',
'time': 'tempo',
'jackpot': 'jackpot',
'escaped': 'ESCAPOU',
'max_win': 'VITÓRIA MÁXIMA',
'check_internet': 'Verifique sua conexão com a internet',
'websocket_disconected': 'Websocket desconectado',
'websocket_connection_error': 'Erro de conexão Websocket!',
'session_expired': 'Sessão expirada, recarregue',
'remaining_bets': 'Apostas restantes',
'stop_autoplay': 'PARAR',
'autoplay_and_autocashout': 'AUTOMÁTICO E AUTO SAQUE',
'autoplay_and_autocashout_ss': 'Escolha entre manual e automático',
'autoplay_and_autocashout_p1': 'O jogador pode ativar o automático, apostando a cada rodada com o valor da aposta anterior.',
'autoplay_and_autocashout_p2': 'Um multiplicador de saque automático pode ser configurado, sacando automaticamente se o jogador não for atingido antes.',
'autoplay_and_autocashout_p3': 'O número máximo de rodadas automáticas é ',
'autoplay_button_label': 'Para começar, escolha uma pista.',
'min_bet_amount_is': 'Valor mínimo da aposta é',
'bonus_rounds': 'rodadas bônus',
'bonus_rounds_ss': 'Rodadas bônus com validade',
'bonus_rounds_p1': 'O jogador pode ganhar uma rodada bônus (aposta grátis) em promoções do cassino. Um aviso aparecerá indicando quantidade de apostas, valor por aposta e validade.',
'bonus_rounds_p2': 'Uma vez recebidas, o jogador escolhe quando começar. Ao iniciar, a aposta acontece automaticamente com o valor indicado.',
'bonus_rounds_p3': 'Rodadas bônus podem ter tempo limite e expirar. O prazo aparece abaixo da rodada bônus.',
'bonus_rounds_p4': 'Se o jogador ficar inativo, a rodada bônus ativa é cancelada. O saldo permanece igual.',
'valid_until': 'válido até',
'bonus': 'bônus',
'rounds': 'rodadas',
'win_eur': 'ganho EUR',
'complete_your_bet': 'Complete sua aposta primeiro',
'complete_auto_play': 'Conclua seu jogo automático primeiro',
'yes': 'sim',
'no': 'não',
'play_bonus_rounds': 'Jogar rodadas bônus?',
'bet_history': 'Histórico de apostas',
'jackpot_history': 'Histórico de jackpots',
'ticket_id': 'ID do bilhete',
'created': 'hora de criação',
'currency': 'moeda',
'bet': 'aposta',
'bet_eur': 'aposta EUR',
'lanes': 'pistas',
'cars': 'carros',
'multiplier': 'multiplicador',
'win': 'ganho',
'no_betting_history': 'Nenhum histórico encontrado. Faça uma aposta para aparecer aqui.',
'no_jackpot_history': 'Sem histórico de jackpots.',
'date': 'data',
'user': 'usuário',
'bet_already_active': 'Aposta já ativa',
'please_play_the_game_in_portait_mode': 'Jogue no modo retrato.',
'bonus_history': 'Histórico de bônus',
'bonus_type': 'Tipo de bônus',
'no_bonus_history': 'Sem histórico de bônus.',
'game_menu': 'Menu do jogo',
'game_menu_ss': 'Da esquerda: Início, Histórico, Regras, Atalhos, Sons, Música',
'game_menu_p1': 'No menu, jogadores podem controlar som, atalhos, histórico e regras.',
'game_menu_p2': 'O histórico mostra apostas anteriores e bônus.',
'multisession_title': 'Múltiplas sessões não são permitidas',
'multisession_message': 'A sua sessão foi encerrada porque a mesma conta foi aberta noutro separador ou janela.',
'session_inactivity_warning': 'Devido à inatividade, a sua sessão irá expirar.',
'autoplay_confirmation': 'Valor total para rodadas de jogo automático',
'balance_before': 'Saldo antes',
'balance_after': 'Saldo depois',

};
langArr.br = {
'loading': 'Carregando',
'hotkeys': 'Atalhos',
'hotkeys_enabled': 'Atalhos Ativados',
'enable_hotkeys_checkbox': 'Ative os atalhos mostrados abaixo marcando esta caixa.',
'make_bet': 'Fazer aposta',
'double_bet': 'Dobrar aposta',
'halve_bet': 'Reduzir aposta pela metade',
'min_bet': 'Aposta mínima',
'cashout_key': 'Sacar',
'walk_next_line': 'Andar para a próxima linha',
'max': 'Máximo',
'easy': 'Fácil',
'medium': 'Médio',
'hard': 'Difícil',
'daredevil': 'Corajoso',
'max_profit': 'Lucro Máximo',
'manual': 'Manual',
'auto': 'Automático',
'bet_amount': 'Valor da aposta',
'difficulty': 'Dificuldade',
'payout_on_win': 'Pagamento na vitória',
'number_of_bets': 'Número de apostas',
'on_win': 'Ao ganhar',
'on_loss': 'Ao perder',
'stop_on_profit': 'Parar no lucro',
'stop_on_loss': 'Parar na perda',
'reset': 'Redefinir',
'increase_by': 'Aumentar em',
'cashout': 'SACAR',
'start_game': 'APOSTAR',
'start_auto_game': 'COMEÇAR',
'difficulity_info': 'Informações de dificuldade',
'chance_collision': 'Chance de colisão por jogo',
'evry_25_lane': 'a cada 25 pistas',
'insufficient_funds': 'Fundos insuficientes',
'cashout_inactivity': 'Saque automático por inatividade',
'time_running_out': 'O tempo está acabando! Jogue agora ou seu bilhete será retirado em 30 segundos',
'there_was_error': 'HOUVE UM ERRO, TENTE NOVAMENTE OU RECARREGUE',
'detailed_game_rules': 'Regras Detalhadas do Jogo',
'general_rules': 'REGRAS GERAIS',
'general_rules_p1': '• O multiplicador começa em 1 e vai até ',
'general_rules_p2': '• Os ganhos são calculados multiplicando o valor apostado pelo multiplicador exibido a cada etapa.',
'general_rules_p3': '• Se o pagamento máximo for atingido, o jogo sacará automaticamente nesse valor.',
'progressive_jackpot': 'JACKPOT PROGRESSIVO',
'progressive_jackpot_ss': 'A pista do jackpot e o prêmio possível',
'progressive_jackpot_p1': '% de cada aposta é destinada a um fundo de jackpot progressivo.',
'progressive_jackpot_p2': 'O jackpot é concedido usando uma mecânica "Mystery" ou "must-hit-by". O valor de cada jackpot "must-hit-by" é definido imediatamente após o anterior ser ganho, gerado aleatoriamente e armazenado de forma criptografada no banco de dados remoto.',
'progressive_jackpot_p3': 'Assim que o valor "must-hit-by" for alcançado, o primeiro jogador a apostar terá a chance de ganhar o jackpot. Um símbolo de jackpot aparecerá em uma pista aleatória, e o jogador ganha se alcançar essa pista. Caso saque ou perca antes, o próximo jogador verá o símbolo e terá a chance de ganhar. Esse processo se repete até alguém vencer. Apenas um bilhete/jogador pode ganhar o jackpot.',
'progressive_jackpot_p4': 'NOTA: Rodadas bônus não contribuem para o fundo de jackpot. Durante elas, o jackpot não pode ser ganho.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Quadrado vermelho, localização de colisão certa',
'showdown_p1': 'Depois de sacar, um quadrado vermelho mostrará onde a colisão teria ocorrido se o jogador continuasse.',
'return_to_player': 'RETORNO AO JOGADOR',
'return_to_player_p1': 'O retorno teórico geral ao jogador (RTP) é ',
'return_to_player_p2': 'Os percentuais de RTP são monitorados e verificados por terceiros independentes.',
'disconnection_policy': 'POLÍTICA DE DESCONECTAR',
'disconnection_policy_p1': 'Se a conexão cair após a aposta, ela não será cancelada imediatamente. Se a inatividade durar ',
'disconnection_policy_p2': 'a aposta será sacada automaticamente e o crédito aplicado na conta do jogador.',
'network_latency': 'LATÊNCIA DE REDE',
'network_latency_p1': 'A latência de rede é inevitável. Todas as apostas e saques são válidos apenas quando chegam ao nosso servidor.',
'sound': 'SOM',
'sound_p1': 'O jogo tem música de fundo e efeitos sonoros. Se quiser, é possível desativá-los pelo menu.',
'error_handling': 'TRATAMENTO DE ERROS',
'error_handling_p1': 'Em caso de erro, nosso suporte tentará resolver rapidamente. Se o problema for no jogo, as apostas são canceladas e os valores devolvidos.',
'max_payout': 'Pagamento máximo é ',
'max_bet_is': 'Aposta máxima é ',
'min_bet_is': 'Aposta mínima é ',
'per_bet': 'por aposta.',
'malfunction_voids': 'Falhas anulam todos os Pagamentos e Jogadas.',
'attention_jackpot': 'Atenção, Jackpot na pista ',
'lane': 'pista',
'congratulations': 'parabéns',
'you_won': 'você ganhou',
'balance': 'saldo',
'time': 'tempo',
'jackpot': 'jackpot',
'escaped': 'ESCAPOU',
'max_win': 'VITÓRIA MÁXIMA',
'check_internet': 'Verifique sua conexão com a internet',
'websocket_disconected': 'Websocket desconectado',
'websocket_connection_error': 'Erro de conexão Websocket!',
'session_expired': 'Sessão expirada, recarregue',
'remaining_bets': 'Apostas restantes',
'stop_autoplay': 'PARAR',
'autoplay_and_autocashout': 'AUTOMÁTICO E AUTO SAQUE',
'autoplay_and_autocashout_ss': 'Escolha entre manual e automático',
'autoplay_and_autocashout_p1': 'O jogador pode ativar o automático, apostando a cada rodada com o valor da aposta anterior.',
'autoplay_and_autocashout_p2': 'Um multiplicador de saque automático pode ser configurado, sacando automaticamente se o jogador não for atingido antes.',
'autoplay_and_autocashout_p3': 'O número máximo de rodadas automáticas é ',
'autoplay_button_label': 'Para começar, escolha uma pista.',
'min_bet_amount_is': 'Valor mínimo da aposta é',
'bonus_rounds': 'rodadas bônus',
'bonus_rounds_ss': 'Rodadas bônus com validade',
'bonus_rounds_p1': 'O jogador pode ganhar uma rodada bônus (aposta grátis) em promoções do cassino. Um aviso aparecerá indicando quantidade de apostas, valor por aposta e validade.',
'bonus_rounds_p2': 'Uma vez recebidas, o jogador escolhe quando começar. Ao iniciar, a aposta acontece automaticamente com o valor indicado.',
'bonus_rounds_p3': 'Rodadas bônus podem ter tempo limite e expirar. O prazo aparece abaixo da rodada bônus.',
'bonus_rounds_p4': 'Se o jogador ficar inativo, a rodada bônus ativa é cancelada. O saldo permanece igual.',
'valid_until': 'válido até',
'bonus': 'bônus',
'rounds': 'rodadas',
'win_eur': 'ganho EUR',
'complete_your_bet': 'Complete sua aposta primeiro',
'complete_auto_play': 'Conclua seu jogo automático primeiro',
'yes': 'sim',
'no': 'não',
'play_bonus_rounds': 'Jogar rodadas bônus?',
'bet_history': 'Histórico de apostas',
'jackpot_history': 'Histórico de jackpots',
'ticket_id': 'ID do bilhete',
'created': 'hora de criação',
'currency': 'moeda',
'bet': 'aposta',
'bet_eur': 'aposta EUR',
'lanes': 'pistas',
'cars': 'carros',
'multiplier': 'multiplicador',
'win': 'ganho',
'no_betting_history': 'Nenhum histórico encontrado. Faça uma aposta para aparecer aqui.',
'no_jackpot_history': 'Sem histórico de jackpots.',
'date': 'data',
'user': 'usuário',
'bet_already_active': 'Aposta já ativa',
'please_play_the_game_in_portait_mode': 'Jogue no modo retrato.',
'bonus_history': 'Histórico de bônus',
'bonus_type': 'Tipo de bônus',
'no_bonus_history': 'Sem histórico de bônus.',
'game_menu': 'Menu do jogo',
'game_menu_ss': 'Da esquerda: Início, Histórico, Regras, Atalhos, Sons, Música',
'game_menu_p1': 'No menu, jogadores podem controlar som, atalhos, histórico e regras.',
'game_menu_p2': 'O histórico mostra apostas anteriores e bônus.',
'multisession_title': 'Múltiplas sessões não são permitidas',
'multisession_message': 'A sua sessão foi encerrada porque a mesma conta foi aberta noutro separador ou janela.',
'session_inactivity_warning': 'Devido à inatividade, a sua sessão irá expirar.',
'autoplay_confirmation': 'Valor total para rodadas de jogo automático',
'balance_before': 'Saldo antes',
'balance_after': 'Saldo depois',

};
langArr.ro = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Sesiunile multiple nu sunt permise',
'multisession_message': 'Sesiunea dvs. a fost încheiată deoarece același cont a fost deschis într-un alt tab sau fereastră.',
'session_inactivity_warning': 'Din cauza inactivității, sesiunea dvs. va expira.',
'autoplay_confirmation': 'Suma totală pentru rundele de joc automat',
'balance_before': 'Sold înainte',
'balance_after': 'Sold după',

};
langArr.ru = {
'loading': 'Загрузка',
'hotkeys': 'Горячие клавиши',
'hotkeys_enabled': 'Горячие клавиши включены',
'enable_hotkeys_checkbox': 'Включите горячие клавиши, показанные ниже, установив этот флажок.',
'make_bet': 'Сделать ставку',
'double_bet': 'Удвоить сумму ставки',
'halve_bet': 'Уменьшить ставку вдвое',
'min_bet': 'Минимальная ставка',
'cashout_key': 'Вывод',
'walk_next_line': 'Перейти на следующую линию',
'max': 'Макс',
'easy': 'Легко',
'medium': 'Средне',
'hard': 'Трудно',
'daredevil': 'Смельчак',
'max_profit': 'Максимальная прибыль',
'manual': 'Ручной',
'auto': 'Авто',
'bet_amount': 'Сумма ставки',
'difficulty': 'Сложность',
'payout_on_win': 'Выплата при выигрыше',
'number_of_bets': 'Количество ставок',
'on_win': 'При выигрыше',
'on_loss': 'При проигрыше',
'stop_on_profit': 'Остановить при прибыли',
'stop_on_loss': 'Остановить при проигрыше',
'reset': 'Сброс',
'increase_by': 'Увеличить на',
'cashout': 'ВЫВОД',
'start_game': 'СТАВКА',
'start_auto_game': 'СТАРТ',
'difficulity_info': 'Информация о сложности',
'chance_collision': 'Шанс столкновения в игре',
'evry_25_lane': 'на каждые 25 линий',
'insufficient_funds': 'Недостаточно средств',
'cashout_inactivity': 'Авто-вывод при бездействии',
'time_running_out': 'Время на исходе! Играйте сейчас или ваш билет будет автоматически отозван через 30 секунд',
'there_was_error': 'ПРОИЗОШЛА ОШИБКА, ПОПРОБУЙТЕ ЕЩЁ РАЗ ИЛИ ПЕРЕЗАГРУЗИТЕ',
'detailed_game_rules': 'Подробные правила игры',
'general_rules': 'ОБЩИЕ ПРАВИЛА',
'general_rules_p1': '• Множитель начинается с 1 и увеличивается до ',
'general_rules_p2': '• Выигрыш рассчитывается путем умножения ставки на множитель, отображаемый на каждом этапе.',
'general_rules_p3': '• Если достигнут максимальный коэффициент выплаты, игра автоматически завершится с этим значением.',
'progressive_jackpot': 'ПРОГРЕССИВНЫЙ ДЖЕКПОТ',
'progressive_jackpot_ss': 'Полоса джекпота и возможный выигрыш',
'progressive_jackpot_p1': '% от каждой ставки направляется в фонд прогрессивного джекпота.',
'progressive_jackpot_p2': 'Джекпот разыгрывается с использованием механики "Мистерия" или "Должен выпасть до". Значение каждого "Должен выпасть до" джекпота определяется сразу после выигрыша предыдущего джекпота с помощью генератора случайных чисел и сохраняется как зашифрованное значение в удаленной базе данных. Значение зашифровано и скрыто, и никто не знает его заранее.',
'progressive_jackpot_p3': 'Когда достигнуто значение "Должен выпасть до", первый игрок, сделавший ставку после этого, получит шанс выиграть джекпот. Символ джекпота появится на случайной дорожке, и игрок выиграет джекпот, если достигнет этой дорожки. Если игрок не достигнет дорожки с символом джекпота из-за вывода средств или проигрыша, следующий случайный игрок, сделавший ставку, увидит появление символа джекпота и получит шанс на выигрыш. Этот процесс повторяется до тех пор, пока джекпот не будет выигран. Только один билет/игрок может выиграть джекпот.',
'progressive_jackpot_p4': 'ПРИМЕЧАНИЕ: Бонусный раунд не участвует в формировании джекпот-фонда. Во время бонусного раунда джекпот не может быть выигран.',
'showdown': 'РАЗВЯЗКА',
'showdown_ss': 'Красный квадрат – место неизбежного столкновения',
'showdown_p1': 'После вывода средств у игрока появится красный квадрат в том месте, где произошло бы столкновение, если бы он продолжил движение по дорожкам.',
'return_to_player': 'ВОЗВРАТ ИГРОКУ',
'return_to_player_p1': 'Общий теоретический возврат игроку (RTP) составляет ',
'return_to_player_p2': 'Процент RTP непрерывно контролируется и проверяется независимыми третьими сторонами.',
'disconnection_policy': 'ПОЛИТИКА ПРИ ОБРЫВЕ СОЕДИНЕНИЯ',
'disconnection_policy_p1': 'Если соединение теряется после размещения ставки, ставка не отменяется сразу. Если бездействие игрока достигает ',
'disconnection_policy_p2': 'ставка будет автоматически выведена, и средства будут зачислены на счет игрока.',
'network_latency': 'ЗАДЕРЖКА СЕТИ',
'network_latency_p1': 'Задержка сети – это неизбежная часть интернет-соединения. Мы считаем все ставки и выводы действительными только в момент их поступления на наш сервер, независимо от продолжительности сетевой задержки.',
'sound': 'ЗВУК',
'sound_p1': 'Игра разработана с учетом красивой фоновой музыки и звуковых эффектов. Если вы хотите отключить музыку и/или звуковые эффекты, вы можете сделать это через меню игры.',
'error_handling': 'ОБРАБОТКА ОШИБОК',
'error_handling_p1': 'В случае ошибки наша служба поддержки постарается решить проблему как можно скорее и возобновить нормальную работу игры. В случае неисправности самой игры все ставки будут отменены, а суммы ставок возвращены игрокам.',
'max_payout': 'Максимальная выплата составляет ',
'max_bet_is': 'Максимальная ставка составляет ',
'min_bet_is': 'Минимальная ставка составляет ',
'per_bet': 'за ставку.',
'malfunction_voids': 'Сбой аннулирует все выплаты и игры.',
'attention_jackpot': 'Внимание, Джекпот на дорожке ',
'lane': 'дорожка',
'congratulations': 'поздравляем',
'you_won': 'вы выиграли',
'balance': 'баланс',
'time': 'время',
'jackpot': 'джекпот',
'escaped': 'СПАСЕНИЕ',
'max_win': 'МАКСИМАЛЬНЫЙ ВЫИГРЫШ',
'check_internet': 'Пожалуйста, проверьте ваше интернет-соединение',
'websocket_disconected': 'Websocket отключен',
'websocket_connection_error': 'Ошибка соединения с Websocket!',
'session_expired': 'Сессия истекла, пожалуйста, перезагрузите страницу',
'remaining_bets': 'Оставшиеся ставки',
'stop_autoplay': 'СТОП',
'autoplay_and_autocashout': 'АВТОИГРА И АВТОВЫВОД',
'autoplay_and_autocashout_ss': 'Выбор между ручной игрой и автоигрой',
'autoplay_and_autocashout_p1': 'Игрок может активировать опцию автоигры, при которой ставка автоматически размещается в каждом новом раунде, используя сумму ставки из предыдущего раунда.',
'autoplay_and_autocashout_p2': 'Автоматический множитель вывода можно выбрать на игровом экране. Если он установлен, игра автоматически завершится, если игрок не столкнется до достижения выбранного множителя.',
'autoplay_and_autocashout_p3': 'Максимальное количество раундов автоигры составляет ',
'autoplay_button_label': 'Чтобы начать, выберите дорожку.',
'min_bet_amount_is': 'Минимальная сумма ставки составляет',
'bonus_rounds': 'бонусные раунды',
'bonus_rounds_ss': 'Бонусные раунды с периодом действия',
'bonus_rounds_p1': 'Игрок может получить бонусный раунд (например, бесплатную ставку) в рамках акции казино. На экране появится всплывающее сообщение, информирующее игрока о начисленных бонусных раундах, количестве ставок, сумме на ставку и, возможно, сроке действия.',
'bonus_rounds_p2': 'После начисления бонусного раунда игрок может выбрать, когда его использовать. Как только бонусный раунд активирован, автоматически размещается ставка с указанной суммой, и игрок сам решает, когда вывести выигрыш.',
'bonus_rounds_p3': 'Бонусные раунды могут иметь ограниченный срок действия, после которого они аннулируются и становятся недоступными. Если срок действия установлен, он отображается под бонусным раундом.',
'bonus_rounds_p4': 'Если игрок бездействует, активный бонусный раунд может быть отменен. В этом случае количество бонусных раундов уменьшается, а баланс игрока остается неизменным.',
'valid_until': 'срок до',
'bonus': 'бонус',
'rounds': 'раунды',
'win_eur': 'выигрыш в EUR',
'complete_your_bet': 'Пожалуйста, завершите свою ставку',
'complete_auto_play': 'Пожалуйста, завершите свою автоигру',
'yes': 'да',
'no': 'нет',
'play_bonus_rounds': 'Играть в бонусные раунды?',
'bet_history': 'История ставок',
'jackpot_history': 'История джекпотов',
'ticket_id': 'ID билета',
'created': 'время создания',
'currency': 'валюта',
'bet': 'ставка',
'bet_eur': 'ставка в EUR',
'lanes': 'дорожки',
'cars': 'машины',
'multiplier': 'множитель',
'win': 'выигрыш',
'no_betting_history': 'История ставок не найдена. Сделайте ставку, и она появится здесь.',
'no_jackpot_history': 'История джекпотов отсутствует.',
'date': 'дата',
'user': 'пользователь',
'bet_already_active': 'Ставка уже активна',
'please_play_the_game_in_portait_mode': 'Пожалуйста, играйте в портретном режиме.',
'bonus_history': 'История бонусов',
'bonus_type': 'Тип бонуса',
'no_bonus_history': 'История бонусов отсутствует.',
'game_menu': 'Игровое меню',
'game_menu_ss': 'Слева направо: Главная, История ставок, Правила игры, Горячие клавиши, Настройки звуковых эффектов, Музыка',
'game_menu_p1': 'Через игровое меню игроки могут управлять настройками звука, горячими клавишами, а также открывать историю игры и правила.',
'game_menu_p2': 'История игры покажет окно с предыдущими ставками и историей бонусов.',
'multisession_title': 'Мультисессия не разрешена',
'multisession_message': 'Ваша сессия была прервана, так как тот же аккаунт был открыт в другой вкладке или окне.',
'session_inactivity_warning': 'Из-за бездействия ваша сессия скоро истечет.',
'autoplay_confirmation': 'Общая сумма для раундов автоигры',
'balance_before': 'Баланс до',
'balance_after': 'Баланс после',

};
langArr.sq = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Seancat e shumta nuk lejohen',
'multisession_message': 'Seanca juaj është ndërprerë sepse i njëjti llogari është hapur në një skedë ose dritare tjetër.',
'session_inactivity_warning': 'Për shkak të paaftësisë, seanca juaj do të skadojë.',
'autoplay_confirmation': 'Shuma totale për raundet e lojës automatike',
'balance_before': 'Bilanci para',
'balance_after': 'Bilanci pas',

};
langArr.sv = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Flera sessioner är inte tillåtna',
'multisession_message': 'Din session har avslutats eftersom samma konto öppnades i en annan flik eller ett annat fönster.',
'session_inactivity_warning': 'På grund av inaktivitet kommer din session snart att gå ut.',
'autoplay_confirmation': 'Totalt belopp för autoplay-rundor',
'balance_before': 'Saldo före',
'balance_after': 'Saldo efter',

};
langArr.tr = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Çoklu oturumlara izin verilmez',
'multisession_message': 'Aynı hesap başka bir sekmede veya pencerede açıldığı için oturumunuz sonlandırıldı.',
'session_inactivity_warning': 'Etkinlik olmadığından oturumunuz yakında sona erecek.',
'autoplay_confirmation': 'Otomatik oyun turları için toplam tutar',
'balance_before': 'Bahis öncesi bakiye',
'balance_after': 'Bahis sonrası bakiye',

};
langArr.uk = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Мультисесія не дозволена',
'multisession_message': 'Ваша сесія була перервана, оскільки той самий обліковий запис був відкритий в іншій вкладці або вікні.',
'session_inactivity_warning': 'Через бездіяльність ваша сесія скоро закінчиться.',
'autoplay_confirmation': 'Загальна сума для раундів автовідтворення',
'balance_before': 'Баланс до',
'balance_after': 'Баланс після',

};
langArr.sr = {
'loading': 'Učitavanje',
'hotkeys': 'Prečice',
'hotkeys_enabled': 'Prečice aktivne',
'enable_hotkeys_checkbox': 'Omogući prečice aktiviranjem ove opcije.',
'make_bet': 'Uplati tiket',
'double_bet': 'Dupliraj ulog',
'halve_bet': 'Prepolovi ulog',
'min_bet': 'Minimalni ulog',
'cashout_key': 'Isplata',
'walk_next_line': 'Pređi u sledeću traku',
'max': 'Max',
'easy': 'Lako',
'medium': 'Osrednje',
'hard': 'Teško',
'daredevil': 'Izazovno',
'max_profit': 'Max Profit',
'manual': 'Ručno',
'auto': 'Automatski',
'bet_amount': 'Iznos opklade',
'difficulty': 'Težina',
'payout_on_win': 'Isplata po dobitku',
'number_of_bets': 'Broj opklada',
'on_win': 'po dobitku',
'on_loss': 'po gubitku',
'stop_on_profit': 'Prekini na profitu',
'stop_on_loss': 'Prekini na gubitku',
'reset': 'Reset',
'increase_by': 'Povećaj za',
'cashout': 'ISPLATI TIKET',
'start_game': 'UPLATI TIKET',
'start_auto_game': 'START',
'difficulity_info': 'Težina igre',
'chance_collision': 'Šansa za sudar po igri',
'evry_25_lane': 'za svih 25 traka',
'insufficient_funds': 'Nemate dovoljno novca',
'cashout_inactivity': 'Isplata usled neaktivnosti',
'time_running_out': 'Vreme ističe! Igraj odmah ili će tvoj tiket biti isplaćen u narednih 30 sekundi',
'there_was_error': 'Dogodila se greška! Učitaj igru ponovo.',
'detailed_game_rules': 'Detaljna Pravila Igre',
'general_rules': 'OPŠTA PRAVILA',
'general_rules_p1': '• Množilac počinje sa 1 i ide do ',
'general_rules_p2': '• Dobitak se izračunava množenjem opklade sa množiteljem u trenutku klika na dugme ISPLATI TIKET.',
'general_rules_p3': '• Ako je dostignut maksimalni dobitak opklada se automatski unovčava.',
'progressive_jackpot': 'PROGRESIVNI DŽEKPOT',
'progressive_jackpot_ss': 'Džekpot traka i mogućnost osvajanja',
'progressive_jackpot_p1': '% od svakog uloga se izdvaja u fond za progresivni džekpot.',
'progressive_jackpot_p2': 'Džekpot se dodeljuje putem mehanike "Mistery" ili "must-hit-by". Vrednost svakog "must-hit-by" džekpota se određuje odmah nakon što prethodni džekpot bude osvojen, koristeći generator slučajnih brojeva. Ta vrednost se čuva kao šifrovani broj u bazi podataka, što znači da je skrivena i nepoznata.',
'progressive_jackpot_p3': 'Kada se dostigne vrednost "must-hit-by", prvi igrač koji uloži nakon toga imaće priliku da osvoji džekpot. Simbol džekpota će se pojaviti na nasumičnoj traci, a džekpot se osvaja ako igrač stigne do trake sa džekpot simbolom. Ako igrač ne stigne do trake sa simbolom džekpota zbog isplate ili sudara, sledeći igrač koji uloži videće simbol džekpota i imati priliku da ga osvoji. Ovaj proces se ponavlja dok džekpot ne bude osvojen. Samo jedan igrač/tiket može da osvoji džekpot.',
'progressive_jackpot_p4': 'NAPOMENA: Besplatne opklade tj. bonus runde ne učestvuju u fondu za progresivni džekpot. Džekpot ne može biti osvoje tokom bonus runde.',
'showdown': 'OTKRIVANJE',
'showdown_ss': 'Crveni kvadrad, mesto garantovanog sudara',
'showdown_p1': 'Nakon izvršene isplate, crveni kvadrat će biti prikazan na poziciji gde bi se sudar dogodio da je igrač nastavio sa igrom.',
'return_to_player': 'POVRAĆAJ IGRAČU',
'return_to_player_p1': 'Ukupni teoretski povraćaj igraču (RTP) je ',
'return_to_player_p2': 'Procente RTP -a stalno prate i verifikuju nezavisne treće strane.',
'disconnection_policy': 'POLITIKA POVEZIVANJA',
'disconnection_policy_p1': 'Ako se veza prekine nakon postavljanja opklade, opklada se neće poništiti. Ako je igrač neaktivan više od ',
'disconnection_policy_p2': 's opklada će biti automatski isplaćena a krediti vraćeni na račun igrača.',
'network_latency': 'KAŠNJENJA U MREŽI',
'network_latency_p1': 'Kašnjenja prilikom prenosa podataka u mreži su sastavni deo funkcionisanja interneta. Akcije Uplate i Isplate su validne onoga trenutka kada ti zahtevi stignu na server, bez obzira na to kada je igrač inicirao akciju na svojoj strani.',
'sound': 'ZVUK',
'sound_p1': 'Igra je dizajnirana sa prelepom muzikom u pozadini i zvučnim efektima. Ako želite da ugasite muziku ili zvučne efekte korisite ikone za kontrolu zvuka iz menija igre.',
'error_handling': 'U SLUČAJU GREŠKE',
'error_handling_p1': 'U slučaju greške naš tim za podršku će pokušati rešiti problem što je pre moguće. U slučaju problema sa samom igrom, sve opklade će biti poništene, a iznos uloga vraćen igračima.',
'max_payout': 'Maksimalna isplata je ',
'max_bet_is': 'Maksimalni ulog je ',
'min_bet_is': 'Minimalni ulog je ',
'per_bet': 'po opkladi.',
'malfunction_voids': 'Neispravnost u radu poništava sve isplate i igre.',
'attention_jackpot': 'Pažnja, Džekpot na traci ',
'lane': 'traka',
'congratulations': 'bravo',
'you_won': 'osvojio si',
'balance': 'balans',
'time': 'vreme',
'jackpot': 'džekpot',
'escaped': 'POBEGAO',
'max_win': 'MAX DOBITAK',
'check_internet': 'Molimo proverite internet konekciju',
'websocket_disconected': 'Websocket diskonektovan',
'websocket_connection_error': 'Websocket greska u konekciji !',
'session_expired': 'Sesija je istekla',
'remaining_bets': 'Preostale opklade',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTO-IGRA I AUTO-ISPLATA',
'autoplay_and_autocashout_ss': 'Izbor ručne i automatske igre',
'autoplay_and_autocashout_p1': 'Igrač može aktivirati opciju auto-igra gde se opklada automatski stavlja za svaku novu rundu koristeći iznos opklade iz prethodne runde. ',
'autoplay_and_autocashout_p2': 'Odabir množioca za svaku partiju se vrši sa ekran igra. Kada je množilac podešen igra će automatski izvršiti isplatu ako igrač ne doživi sudar pre nego što dostigne izabrani množilac.',
'autoplay_and_autocashout_p3': 'Maskimalan broj rundi u automatskoj igri je ',
'autoplay_button_label': 'Za pocetak, izaberi traku.',
'min_bet_amount_is': 'Min iznos opklade je',
'bonus_rounds': 'bonus runde',
'bonus_rounds_ss': 'Prikaz bonus rundi sa rokom važenja',
'bonus_rounds_p1': 'Igrač može biti nagrađen besplatnim opkladama u vidu bonus rundi tokom promocije od strane kazina. Na ekranu će iskočiti slika koja obaveštava igrača o dodeljenim besplatnim rundama, broju rundi, iznosu po opkladi i opciono roku važenja.',
'bonus_rounds_p2': 'Nakon što se dodele bonus runde, igrač može izabrati kada počinje besplatnu rundu opklade. Nakon što započne runda besplatnih opklada, postavlja se automatska opklada sa navedenim ulogom, a na igraču je da isplati u svakom trenutku.',
'bonus_rounds_p3': 'Besplatne opklade mogu imati rok važenja nakon čega ističu i ne mogu se koristiti. Rok važenja, ako postoji, je prikazan ispod bonus rundi.',
'bonus_rounds_p4': 'Neaktivnost igrača moze prouzrokovati otkazivanje aktivne bonus runde. U tom slučaju, broj bonus rundi se smanjuje a balans igrača ostaje nepromenjen.',
'valid_until': 'važi do',
'bonus': 'bonus',
'rounds': 'runda',
'win_eur': 'dobitak EUR',
'complete_your_bet': 'Prvo završite vašu opkladu',
'complete_auto_play': 'Prvo završite vašu auto-igru',
'yes': 'da',
'no': 'ne',
'play_bonus_rounds': 'Igraj Bonus runde?',
'bet_history': 'Istorija opklada',
'jackpot_history': 'Istorija džekpota',
'ticket_id': 'Ticket ID',
'created': 'vreme kreiranja',
'currency': 'valuta',
'bet': 'ulog',
'bet_eur': 'ulog EUR',
'lanes': 'trake',
'cars': 'automobili',
'multiplier': 'množilac',
'win': 'dobitak',
'no_betting_history': 'Istorija opklada nije pronađena. Napravite opkladu i ona će se pojaviti ovde.',
'no_jackpot_history': 'Nema dostupne istorije džekpota.',
'date': 'datum',
'user': 'igrač',
'bet_already_active': 'Opklada je već aktivna',
'please_play_the_game_in_portait_mode': 'Molim vas igrajte u portret modu.',
'bonus_history': 'Istorija bonusa',
'bonus_type': 'Tip bonusa',
'no_bonus_history': 'Nema dostupne istorije bonusa.',
'game_menu': 'MENI IGRE',
'game_menu_ss': 'Sa leva na desno: povratak na početak, istorija opklada, pravila igre, prečice, zvučni efekti, muzika',
'game_menu_p1': 'Kroz meni igre, igrači mogu kontrolisati opcije zvuka, prečice na tastaturi, otvoriti istoriju opklada i pravila igre.',
'game_menu_p2': 'Istorija oplada prikazuje prethodne opklade i istoriju bonusa.',
'multisession_title': 'Više sesija nije dozvoljeno',
'multisession_message': 'Vaša sesija je prekinuta jer je isti nalog otvoren u drugom prozoru ili kartici.',
'session_inactivity_warning': 'Zbog neaktivnosti, vaša sesija će uskoro isteći.',
'autoplay_confirmation': 'Ukupan iznos za autoplay runde',
'balance_before': 'Balans pre',
'balance_after': 'Balans posle',

};
langArr.rs = {
'loading': 'Učitavanje',
'hotkeys': 'Prečice',
'hotkeys_enabled': 'Prečice aktivne',
'enable_hotkeys_checkbox': 'Omogući prečice aktiviranjem ove opcije.',
'make_bet': 'Uplati tiket',
'double_bet': 'Dupliraj ulog',
'halve_bet': 'Prepolovi ulog',
'min_bet': 'Minimalni ulog',
'cashout_key': 'Isplata',
'walk_next_line': 'Pređi u sledeću traku',
'max': 'Max',
'easy': 'Lako',
'medium': 'Osrednje',
'hard': 'Teško',
'daredevil': 'Izazovno',
'max_profit': 'Max Profit',
'manual': 'Ručno',
'auto': 'Automatski',
'bet_amount': 'Iznos opklade',
'difficulty': 'Težina',
'payout_on_win': 'Isplata po dobitku',
'number_of_bets': 'Broj opklada',
'on_win': 'po dobitku',
'on_loss': 'po gubitku',
'stop_on_profit': 'Prekini na profitu',
'stop_on_loss': 'Prekini na gubitku',
'reset': 'Reset',
'increase_by': 'Povećaj za',
'cashout': 'ISPLATI TIKET',
'start_game': 'UPLATI TIKET',
'start_auto_game': 'START',
'difficulity_info': 'Težina igre',
'chance_collision': 'Šansa za sudar po igri',
'evry_25_lane': 'za svih 25 traka',
'insufficient_funds': 'Nemate dovoljno novca',
'cashout_inactivity': 'Isplata usled neaktivnosti',
'time_running_out': 'Vreme ističe! Igraj odmah ili će tvoj tiket biti isplaćen u narednih 30 sekundi',
'there_was_error': 'Dogodila se greška! Učitaj igru ponovo.',
'detailed_game_rules': 'Detaljna Pravila Igre',
'general_rules': 'OPŠTA PRAVILA',
'general_rules_p1': '• Množilac počinje sa 1 i ide do ',
'general_rules_p2': '• Dobitak se izračunava množenjem opklade sa množiteljem u trenutku klika na dugme ISPLATI TIKET.',
'general_rules_p3': '• Ako je dostignut maksimalni dobitak opklada se automatski unovčava.',
'progressive_jackpot': 'PROGRESIVNI DŽEKPOT',
'progressive_jackpot_ss': 'Džekpot traka i mogućnost osvajanja',
'progressive_jackpot_p1': '% od svakog uloga se izdvaja u fond za progresivni džekpot.',
'progressive_jackpot_p2': 'Džekpot se dodeljuje putem mehanike "Mistery" ili "must-hit-by". Vrednost svakog "must-hit-by" džekpota se određuje odmah nakon što prethodni džekpot bude osvojen, koristeći generator slučajnih brojeva. Ta vrednost se čuva kao šifrovani broj u bazi podataka, što znači da je skrivena i nepoznata.',
'progressive_jackpot_p3': 'Kada se dostigne vrednost "must-hit-by", prvi igrač koji uloži nakon toga imaće priliku da osvoji džekpot. Simbol džekpota će se pojaviti na nasumičnoj traci, a džekpot se osvaja ako igrač stigne do trake sa džekpot simbolom. Ako igrač ne stigne do trake sa simbolom džekpota zbog isplate ili sudara, sledeći igrač koji uloži videće simbol džekpota i imati priliku da ga osvoji. Ovaj proces se ponavlja dok džekpot ne bude osvojen. Samo jedan igrač/tiket može da osvoji džekpot.',
'progressive_jackpot_p4': 'NAPOMENA: Besplatne opklade tj. bonus runde ne učestvuju u fondu za progresivni džekpot. Džekpot ne može biti osvoje tokom bonus runde.',
'showdown': 'OTKRIVANJE',
'showdown_ss': 'Crveni kvadrad, mesto garantovanog sudara',
'showdown_p1': 'Nakon izvršene isplate, crveni kvadrat će biti prikazan na poziciji gde bi se sudar dogodio da je igrač nastavio sa igrom.',
'return_to_player': 'POVRAĆAJ IGRAČU',
'return_to_player_p1': 'Ukupni teoretski povraćaj igraču (RTP) je ',
'return_to_player_p2': 'Procente RTP -a stalno prate i verifikuju nezavisne treće strane.',
'disconnection_policy': 'POLITIKA POVEZIVANJA',
'disconnection_policy_p1': 'Ako se veza prekine nakon postavljanja opklade, opklada se neće poništiti. Ako je igrač neaktivan više od ',
'disconnection_policy_p2': 's opklada će biti automatski isplaćena a krediti vraćeni na račun igrača.',
'network_latency': 'KAŠNJENJA U MREŽI',
'network_latency_p1': 'Kašnjenja prilikom prenosa podataka u mreži su sastavni deo funkcionisanja interneta. Akcije Uplate i Isplate su validne onoga trenutka kada ti zahtevi stignu na server, bez obzira na to kada je igrač inicirao akciju na svojoj strani.',
'sound': 'ZVUK',
'sound_p1': 'Igra je dizajnirana sa prelepom muzikom u pozadini i zvučnim efektima. Ako želite da ugasite muziku ili zvučne efekte korisite ikone za kontrolu zvuka iz menija igre.',
'error_handling': 'U SLUČAJU GREŠKE',
'error_handling_p1': 'U slučaju greške naš tim za podršku će pokušati rešiti problem što je pre moguće. U slučaju problema sa samom igrom, sve opklade će biti poništene, a iznos uloga vraćen igračima.',
'max_payout': 'Maksimalna isplata je ',
'max_bet_is': 'Maksimalni ulog je ',
'min_bet_is': 'Minimalni ulog je ',
'per_bet': 'po opkladi.',
'malfunction_voids': 'Neispravnost u radu poništava sve isplate i igre.',
'attention_jackpot': 'Pažnja, Džekpot na traci ',
'lane': 'traka',
'congratulations': 'bravo',
'you_won': 'osvojio si',
'balance': 'balans',
'time': 'vreme',
'jackpot': 'džekpot',
'escaped': 'POBEGAO',
'max_win': 'MAX DOBITAK',
'check_internet': 'Molimo proverite internet konekciju',
'websocket_disconected': 'Websocket diskonektovan',
'websocket_connection_error': 'Websocket greska u konekciji !',
'session_expired': 'Sesija je istekla',
'remaining_bets': 'Preostale opklade',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTO-IGRA I AUTO-ISPLATA',
'autoplay_and_autocashout_ss': 'Izbor ručne i automatske igre',
'autoplay_and_autocashout_p1': 'Igrač može aktivirati opciju auto-igra gde se opklada automatski stavlja za svaku novu rundu koristeći iznos opklade iz prethodne runde. ',
'autoplay_and_autocashout_p2': 'Odabir množioca za svaku partiju se vrši sa ekran igra. Kada je množilac podešen igra će automatski izvršiti isplatu ako igrač ne doživi sudar pre nego što dostigne izabrani množilac.',
'autoplay_and_autocashout_p3': 'Maskimalan broj rundi u automatskoj igri je ',
'autoplay_button_label': 'Za pocetak, izaberi traku.',
'min_bet_amount_is': 'Min iznos opklade je',
'bonus_rounds': 'bonus runde',
'bonus_rounds_ss': 'Prikaz bonus rundi sa rokom važenja',
'bonus_rounds_p1': 'Igrač može biti nagrađen besplatnim opkladama u vidu bonus rundi tokom promocije od strane kazina. Na ekranu će iskočiti slika koja obaveštava igrača o dodeljenim besplatnim rundama, broju rundi, iznosu po opkladi i opciono roku važenja.',
'bonus_rounds_p2': 'Nakon što se dodele bonus runde, igrač može izabrati kada počinje besplatnu rundu opklade. Nakon što započne runda besplatnih opklada, postavlja se automatska opklada sa navedenim ulogom, a na igraču je da isplati u svakom trenutku.',
'bonus_rounds_p3': 'Besplatne opklade mogu imati rok važenja nakon čega ističu i ne mogu se koristiti. Rok važenja, ako postoji, je prikazan ispod bonus rundi.',
'bonus_rounds_p4': 'Neaktivnost igrača moze prouzrokovati otkazivanje aktivne bonus runde. U tom slučaju, broj bonus rundi se smanjuje a balans igrača ostaje nepromenjen.',
'valid_until': 'važi do',
'bonus': 'bonus',
'rounds': 'runda',
'win_eur': 'dobitak EUR',
'complete_your_bet': 'Prvo završite vašu opkladu',
'complete_auto_play': 'Prvo završite vašu auto-igru',
'yes': 'da',
'no': 'ne',
'play_bonus_rounds': 'Igraj Bonus runde?',
'bet_history': 'Istorija opklada',
'jackpot_history': 'Istorija džekpota',
'ticket_id': 'Ticket ID',
'created': 'vreme kreiranja',
'currency': 'valuta',
'bet': 'ulog',
'bet_eur': 'ulog EUR',
'lanes': 'trake',
'cars': 'automobili',
'multiplier': 'množilac',
'win': 'dobitak',
'no_betting_history': 'Istorija opklada nije pronađena. Napravite opkladu i ona će se pojaviti ovde.',
'no_jackpot_history': 'Nema dostupne istorije džekpota.',
'date': 'datum',
'user': 'igrač',
'bet_already_active': 'Opklada je već aktivna',
'please_play_the_game_in_portait_mode': 'Molim vas igrajte u portret modu.',
'bonus_history': 'Istorija bonusa',
'bonus_type': 'Tip bonusa',
'no_bonus_history': 'Nema dostupne istorije bonusa.',
'game_menu': 'MENI IGRE',
'game_menu_ss': 'Sa leva na desno: povratak na početak, istorija opklada, pravila igre, prečice, zvučni efekti, muzika',
'game_menu_p1': 'Kroz meni igre, igrači mogu kontrolisati opcije zvuka, prečice na tastaturi, otvoriti istoriju opklada i pravila igre.',
'game_menu_p2': 'Istorija oplada prikazuje prethodne opklade i istoriju bonusa.',
'multisession_title': 'Više sesija nije dozvoljeno',
'multisession_message': 'Vaša sesija je prekinuta jer je isti nalog otvoren u drugom prozoru ili kartici.',
'session_inactivity_warning': 'Zbog neaktivnosti, vaša sesija će uskoro isteći.',
'autoplay_confirmation': 'Ukupan iznos za autoplay runde',
'balance_before': 'Balans pre',
'balance_after': 'Balans posle',
};
langArr.zh = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': '不允许多个会话',
'multisession_message': '您的会话已被终止，因为同一账户在另一个标签页或窗口中被打开。',
'session_inactivity_warning': '由于不活动，您的会话即将过期。',
'autoplay_confirmation': '自动游戏回合的总金额',
'balance_before': '下注前余额',
'balance_after': '下注后余额',

};
langArr.hi = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'मल्टी-सेशन की अनुमति नहीं है',
'multisession_message': 'आपका सत्र समाप्त कर दिया गया है क्योंकि उसी खाते को किसी अन्य टैब या विंडो में खोला गया था।',
'session_inactivity_warning': 'निष्क्रियता के कारण, आपका सत्र जल्द ही समाप्त हो जाएगा।',
'autoplay_confirmation': 'ऑटोप्ले राउंड के लिए कुल राशि',
'balance_before': 'दांव से पहले शेष',
'balance_after': 'दांव के बाद शेष',

};
langArr.cs = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Více relací není povoleno',
'multisession_message': 'Vaše relace byla ukončena, protože stejný účet byl otevřen v jiné kartě nebo okně.',
'session_inactivity_warning': 'Kvůli nečinnosti vaše relace brzy vyprší.',
'autoplay_confirmation': 'Celková částka pro kola automatické hry',
'balance_before': 'Zůstatek před',
'balance_after': 'Zůstatek po',

};
langArr.id = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Multi-sesi tidak diizinkan',
'multisession_message': 'Sesi Anda telah dihentikan karena akun yang sama dibuka di tab atau jendela lain.',
'session_inactivity_warning': 'Karena tidak aktif, sesi Anda akan segera kedaluwarsa.',
'autoplay_confirmation': 'Jumlah total untuk putaran permainan otomatis',
'balance_before': 'Saldo sebelum',
'balance_after': 'Saldo sesudah',

};
langArr.th = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'ไม่อนุญาตให้ใช้หลายเซสชัน',
'multisession_message': 'เซสชันของคุณถูกยกเลิกเนื่องจากมีการเปิดบัญชีเดียวกันในแท็บหรือหน้าต่างอื่น',
'session_inactivity_warning': 'เนื่องจากไม่มีการใช้งาน เซสชันของคุณจะหมดอายุในไม่ช้า',
'autoplay_confirmation': 'จำนวนเงินทั้งหมดสำหรับรอบเล่นอัตโนมัติ',
'balance_before': 'ยอดคงเหลือก่อน',
'balance_after': 'ยอดคงเหลือหลัง',
};
langArr.tl = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Make a bet',
'double_bet': 'Double a bet amount',
'halve_bet': 'Cut the bet in half',
'min_bet': 'Minimal bet amount',
'cashout_key': 'Cashout',
'walk_next_line': 'Walk to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Profit',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Bet amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Payout on Win',
'number_of_bets': 'Number of Bets',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Profit',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'CASHOUT',
'start_game': 'BET',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'insufficient funds',
'cashout_inactivity': 'Party cashout on inactivity',
'time_running_out': 'Time is running out! Play now or your ticket will be withdrawn automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Winnings are calculated by multiplying the bet stake by the multiplier displayed on every step.',
'general_rules_p3': '• If the maximum payout is reached, game will automatically cash out at the maximum payout amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': '% of each stake is dedicated to a progressive jackpot fund.',
'progressive_jackpot_p2': 'Jackpot is awarded using a "Mystery" or "must-hit-by" mechanics. The value of every "must-hit-by" jackpot is determined immediately after the preceding jackpot is won by a random number generator and stored as an encrypted value in the remote database. The value is encrypted and thus hidden and is not known.',
'progressive_jackpot_p3': 'Once the "must-hit-by" value is reached, the first player to place a bet afterward will have the chance to win the jackpot. A jackpot symbol will appear on a random lane, and the jackpot is won if the player reaches the lane with the symbol. If the player does not reach the lane with the jackpot symbol due to either cashing out or crashing, the next random player to place a bet will see the jackpot symbol appear and have the chance to win. This process repeats until the jackpot is won. Only one ticket/player can win the jackpot.',
'progressive_jackpot_p4': 'NOTE: Bonus round does not contribute to a jackpot fund. During the bonus round jackpot cannot be won.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player cashes out, a red square will be displayed at the location where the collision would have occurred if the player had continued skipping lanes.',
'return_to_player': 'RETURN TO PLAYER',
'return_to_player_p1': 'The overall theoretical return to player (RTP) is ',
'return_to_player_p2': 'RTP percentages are continuously monitored and verified by independent third parties.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after a bet is placed, the bet will not be cancelled immediately. If the inactivity from the player reaches ',
'disconnection_policy_p2': 'bet will be auto cashed out and credits will be applied to player’s account.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'Network latency is an unavoidable part of Internet connectivity. We consider all bets and cashouts valid only at the time they reach our server, regardless of the network latency duration.',
'sound': 'SOUND',
'sound_p1': 'The game is designed with beautiful background music and sound effects in mind. Should you wish to disable music and/or sound effects, you may do so through game menu icons.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In the event of an error our support team will try to resolve the issue as soon as possible, and resume with regular game. In case of an issue with a game itself, all bets will be cancelled and stake amount returned to players.',
'max_payout': 'Maximum payout is ',
'max_bet_is': 'Max bet is ',
'min_bet_is': 'Min bet is ',
'per_bet': 'per bet.',
'malfunction_voids': 'Malfunction voids all Pays and Plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Bets',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTOCASHOUT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'A player may activate the autoplay option where a bet is automatically placed for each new round using the bet amount from the previous bet.',
'autoplay_and_autocashout_p2': 'An auto cashout multiplier can be selected from the game screen, and when set, the game will automatically cash-out if the player is not hit before reaching selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Min Bet Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'The Bonus Rounds with validity period',
'bonus_rounds_p1': 'A player may be awarded a bonus round (i.e. free bet) based on a casino promotion. A popup graphic will appear on screen notifying the player about the awarded bonus rounds, number of bets, amount per bet and optionally validity period.',
'bonus_rounds_p2': 'Once they are awarded player may choose when to start the bonus round. Once the bonus round is started, an automatic bet with the specified stake is placed, and it is up to the player to cashout at any given moment.',
'bonus_rounds_p3': 'Bonus rounds could have a time limit, after which they become void and unusable. The validity period, if any, is displayed beneath the bonus round.',
'bonus_rounds_p4': 'Player idleness may result in the cancellation of an active bonus round. In this case, the bonus rounds number is decreased, and the player\'s balance stays the same.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win EUR',
'complete_your_bet': 'Please complete your bet first',
'complete_auto_play': 'Please complete your auto play first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Bet history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Ticket ID',
'created': 'created time',
'currency': 'currency',
'bet': 'bet',
'bet_eur': 'bet EUR',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No betting history found. Make a bet, and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Bet already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'From left: Home, Bet history, Game rules, Keyboard shortcuts, Sound FX settings, Music',
'game_menu_p1': 'Trough game menu, players can control sound options, keyboard shortcuts, and open game history and game rules.',
'game_menu_p2': 'Game history will show window with previous bets and bonusing history.',
'multisession_title': 'Hindi pinapayagan ang maramihang sesyon',
'multisession_message': 'Ang iyong sesyon ay winakasan dahil ang parehong account ay binuksan sa ibang tab o window.',
'session_inactivity_warning': 'Dahil sa kawalan ng aktibidad, ang iyong sesyon ay malapit nang mag-expire.',
'autoplay_confirmation': 'Kabuuang halaga para sa mga autoplay round',
'balance_before': 'Balanse bago',
'balance_after': 'Balanse pagkatapos',

};
langArr.xe = {
'loading': 'Loading',
'hotkeys': 'Hotkeys',
'hotkeys_enabled': 'Hotkeys Enabled',
'enable_hotkeys_checkbox': 'Enable Hotkeys shown below by checking this box.',
'make_bet': 'Start play',
'double_bet': 'Double play amount',
'halve_bet': 'Halve play amount',
'min_bet': 'Minimum play amount',
'cashout_key': 'Collect',
'walk_next_line': 'Move to next line',
'max': 'Max',
'easy': 'Easy',
'medium': 'Medium',
'hard': 'Hard',
'daredevil': 'Daredevil',
'max_profit': 'Max Reward',
'manual': 'Manual',
'auto': 'Auto',
'bet_amount': 'Play amount',
'difficulty': 'Difficulty',
'payout_on_win': 'Reward on Win',
'number_of_bets': 'Number of Plays',
'on_win': 'On Win',
'on_loss': 'On Loss',
'stop_on_profit': 'Stop on Reward',
'stop_on_loss': 'Stop on Loss',
'reset': 'Reset',
'increase_by': 'Increase By',
'cashout': 'COLLECT',
'start_game': 'PLAY',
'start_auto_game': 'START',
'difficulity_info': 'Difficulty Info',
'chance_collision': 'Chance of collision per game',
'evry_25_lane': 'for every 25 lanes',
'insufficient_funds': 'Not enough coins',
'cashout_inactivity': 'Auto collect on inactivity',
'time_running_out': 'Time is running out! Play now or your round will close automatically in 30 sec',
'there_was_error': 'THERE WAS AN ERROR PLEASE TRY AGAIN OR RELOAD',
'detailed_game_rules': 'Detailed Game Rules',
'general_rules': 'GENERAL RULES',
'general_rules_p1': '• The multiplier starts at 1 and goes up to ',
'general_rules_p2': '• Rewards are calculated by multiplying the play amount by the multiplier shown on each step.',
'general_rules_p3': '• If the maximum reward is reached, the game will automatically collect at the maximum reward amount.',
'progressive_jackpot': 'PROGRESSIVE JACKPOT',
'progressive_jackpot_ss': 'The jackpot lane and possible win',
'progressive_jackpot_p1': 'Part of each play contributes to a progressive jackpot pool.',
'progressive_jackpot_p2': 'Jackpot is awarded using a mystery or must-hit-by mechanic. The must-hit-by value is randomly generated and securely stored.',
'progressive_jackpot_p3': 'Once the must-hit-by value is reached, the next player gets a chance to trigger the jackpot lane and win the jackpot reward.',
'progressive_jackpot_p4': 'NOTE: Bonus rounds do not contribute to the jackpot pool and cannot trigger jackpot wins.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Red square, location of certain collision',
'showdown_p1': 'After the player collects, a red square shows where the collision would have happened if play continued.',
'return_to_player': 'RETURN VALUE',
'return_to_player_p1': 'The overall theoretical return value is ',
'return_to_player_p2': 'Return values are continuously monitored and verified.',
'disconnection_policy': 'DISCONNECTION POLICY',
'disconnection_policy_p1': 'If connection is lost after play starts, it will not be cancelled immediately. If inactivity reaches ',
'disconnection_policy_p2': 'the round will be auto-collected and coins will be credited.',
'network_latency': 'NETWORK LATENCY',
'network_latency_p1': 'All play actions and collects are valid only when received by our server.',
'sound': 'SOUND',
'sound_p1': 'Music and sound effects can be enabled or disabled in the game menu.',
'error_handling': 'ERROR HANDLING',
'error_handling_p1': 'In case of a game error, all active plays will be cancelled and coins returned.',
'max_payout': 'Maximum reward is ',
'max_bet_is': 'Max play amount is ',
'min_bet_is': 'Min play amount is ',
'per_bet': 'per play.',
'malfunction_voids': 'Malfunction voids all rewards and plays.',
'attention_jackpot': 'Attention, Jackpot at lane ',
'lane': 'lane',
'congratulations': 'congratulations',
'you_won': 'you won',
'balance': 'balance',
'time': 'time',
'jackpot': 'jackpot',
'escaped': 'ESCAPED',
'max_win': 'MAX WIN',
'check_internet': 'Please check your internet connection',
'websocket_disconected': 'Websocket disconnected',
'websocket_connection_error': 'Websocket connection error !',
'session_expired': 'Session has expired please reload',
'remaining_bets': 'Remaining Plays',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOPLAY AND AUTO COLLECT',
'autoplay_and_autocashout_ss': 'Selection between manual and autoplay',
'autoplay_and_autocashout_p1': 'Autoplay automatically starts a new round using the previous play amount.',
'autoplay_and_autocashout_p2': 'Auto collect can be set so rewards are collected automatically at the selected multiplier.',
'autoplay_and_autocashout_p3': 'The maximum number of autoplay rounds is ',
'autoplay_button_label': 'To begin, choose a lane.',
'min_bet_amount_is': 'Minimum Play Amount is',
'bonus_rounds': 'bonus rounds',
'bonus_rounds_ss': 'Bonus rounds with validity period',
'bonus_rounds_p1': 'Players may receive bonus rounds from promotions with free plays.',
'bonus_rounds_p2': 'Bonus rounds place automatic plays with the defined amount.',
'bonus_rounds_p3': 'Bonus rounds may expire after a time limit.',
'bonus_rounds_p4': 'Player inactivity may cancel an active bonus round.',
'valid_until': 'valid until',
'bonus': 'bonus',
'rounds': 'rounds',
'win_eur': 'win coins',
'complete_your_bet': 'Please complete your play first',
'complete_auto_play': 'Please complete your autoplay first',
'yes': 'yes',
'no': 'no',
'play_bonus_rounds': 'Play bonus rounds?',
'bet_history': 'Play history',
'jackpot_history': 'Jackpot history',
'ticket_id': 'Round ID',
'created': 'created time',
'currency': 'currency',
'bet': 'play',
'bet_eur': 'play coins',
'lanes': 'lanes',
'cars': 'cars',
'multiplier': 'multiplier',
'win': 'win',
'no_betting_history': 'No play history found. Start a play and it will appear here.',
'no_jackpot_history': 'No jackpot history available.',
'date': 'date',
'user': 'user',
'bet_already_active': 'Play already active',
'please_play_the_game_in_portait_mode': 'Please play the game in portrait mode.',
'bonus_history': 'Bonus history',
'bonus_type': 'Bonus type',
'no_bonus_history': 'No bonus history available.',
'game_menu': 'Game menu',
'game_menu_ss': 'Home, History, Rules, Hotkeys, Sound FX, Music',
'game_menu_p1': 'Game menu allows control of sound, shortcuts and history.',
'game_menu_p2': 'History shows previous plays and bonus activity.',
'multisession_title': 'Multisession is not allowed',
'multisession_message': 'Your session has been terminated because the same account was opened in another tab or window.',
'session_inactivity_warning': 'Due to inactivity, your session will expire soon.',
'autoplay_confirmation': 'Total amount for autoplay rounds',
'balance_before': 'Balance before',
'balance_after': 'Balance after',

};
langArr.da = {
'loading': 'Indlæser',
'hotkeys': 'Genvejstaster',
'hotkeys_enabled': 'Genvejstaster aktiveret',
'enable_hotkeys_checkbox': 'Aktivér genvejstasterne nedenfor ved at markere denne boks.',
'make_bet': 'Placér et væddemål',
'double_bet': 'Fordobl indsatsen',
'halve_bet': 'Halvér indsatsen',
'min_bet': 'Minimum indsats',
'cashout_key': 'Udbetal',
'walk_next_line': 'Gå til næste bane',
'max': 'Maks',
'easy': 'Let',
'medium': 'Mellem',
'hard': 'Svær',
'daredevil': 'Vovehals',
'max_profit': 'Maksimal gevinst',
'manual': 'Manuel',
'auto': 'Auto',
'bet_amount': 'Indsatsbeløb',
'difficulty': 'Sværhedsgrad',
'payout_on_win': 'Udbetaling ved gevinst',
'number_of_bets': 'Antal væddemål',
'on_win': 'Ved gevinst',
'on_loss': 'Ved tab',
'stop_on_profit': 'Stop ved gevinst',
'stop_on_loss': 'Stop ved tab',
'reset': 'Nulstil',
'increase_by': 'Forøg med',
'cashout': 'UDBETAL',
'start_game': 'SPIL',
'start_auto_game': 'START',
'difficulity_info': 'Info om sværhedsgrad',
'chance_collision': 'Sandsynlighed for kollision pr. spil',
'evry_25_lane': 'for hver 25 baner',
'insufficient_funds': 'Utilstrækkelige midler',
'cashout_inactivity': 'Automatisk udbetaling ved inaktivitet',
'time_running_out': 'Tiden løber ud! Spil nu, ellers annulleres din billet automatisk om 30 sekunder',
'there_was_error': 'DER OPSTOD EN FEJL, PRØV IGEN ELLER GENINDLÆS',
'detailed_game_rules': 'Detaljerede spilleregler',
'general_rules': 'GENERELLE REGLER',
'general_rules_p1': '• Multiplikatoren starter ved 1 og går op til ',
'general_rules_p2': '• Gevinst beregnes ved at gange indsatsen med multiplikatoren vist for hvert trin.',
'general_rules_p3': '• Når den maksimale udbetaling nås, udbetales gevinsten automatisk.',
'progressive_jackpot': 'PROGRESSIV JACKPOT',
'progressive_jackpot_ss': 'Jackpotbane og mulig gevinst',
'progressive_jackpot_p1': '% af hver indsats går til jackpotpuljen.',
'progressive_jackpot_p2': 'Jackpotten tildeles via "Mystery" eller "must-hit-by"-mekanik. Værdien af hver "must-hit-by"-jackpot bestemmes straks efter, at den forrige jackpot er vundet, af en tilfældighedsgenerator og gemmes krypteret i en ekstern database. Værdien er skjult og ukendt.',
'progressive_jackpot_p3': 'Når "must-hit-by"-værdien er nået, har den første spiller, der placerer et væddemål derefter, chancen for at vinde jackpotten. Et jackpotsymbol vises på en tilfældig bane, og jackpotten vindes, hvis spilleren når banen med symbolet. Hvis spilleren ikke når symbolet pga. udbetaling eller kollision, vil næste spiller få chancen. Processen gentages, indtil jackpotten vindes. Kun én billet/spiller kan vinde jackpotten.',
'progressive_jackpot_p4': 'BEMÆRK: Bonusrunder bidrager ikke til jackpotpuljen. Jackpot kan ikke vindes i bonusrunder.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Rød firkant, placering af sikker kollision',
'showdown_p1': 'Efter at spilleren har udbetalt, vises en rød firkant på det sted, hvor kollisionen ville være sket, hvis spilleren var fortsat.',
'return_to_player': 'TILBAGEBETALING TIL SPILLER',
'return_to_player_p1': 'Den teoretiske tilbagebetaling (RTP) er ',
'return_to_player_p2': 'RTP-procenter overvåges og verificeres løbende af uafhængige tredjeparter.',
'disconnection_policy': 'AFBRYDELSESPOLITIK',
'disconnection_policy_p1': 'Hvis forbindelsen mistes efter et væddemål, annulleres det ikke straks. Hvis spillerens inaktivitet når ',
'disconnection_policy_p2': 'indsatsen udbetales automatisk, og beløbet tilføjes spillerens konto.',
'network_latency': 'NETVÆRKSFORSINKELSE',
'network_latency_p1': 'Netværksforsinkelse er en uundgåelig del af internetforbindelser. Alle væddemål og udbetalinger gælder kun, når de er nået frem til vores server, uanset forsinkelsens længde.',
'sound': 'LYD',
'sound_p1': 'Spillet er designet med flot baggrundsmusik og lydeffekter. Hvis du vil slå musikken og/eller effekterne fra, kan det gøres i menuen.',
'error_handling': 'FEJLHÅNDTERING',
'error_handling_p1': 'Hvis der opstår en fejl, vil vores support forsøge at løse problemet hurtigst muligt, så spillet kan fortsætte. Ved fejl i selve spillet annulleres alle væddemål, og indsatsen tilbagebetales.',
'max_payout': 'Maksimal udbetaling er ',
'max_bet_is': 'Maks indsats er ',
'min_bet_is': 'Min indsats er ',
'per_bet': 'pr. væddemål.',
'malfunction_voids': 'Fejl annullerer alle gevinster og spil.',
'attention_jackpot': 'Opmærksomhed, jackpot på bane ',
'lane': 'bane',
'congratulations': 'Tillykke',
'you_won': 'du har vundet',
'balance': 'saldo',
'time': 'tid',
'jackpot': 'jackpot',
'escaped': 'UNDGIK',
'max_win': 'MAKS GEVINST',
'check_internet': 'Tjek venligst din internetforbindelse',
'websocket_disconected': 'Websocket afbrudt',
'websocket_connection_error': 'Websocket forbindelsesfejl!',
'session_expired': 'Sessionen er udløbet, genindlæs venligst',
'remaining_bets': 'Tilbageværende væddemål',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOSPIN OG AUTO-UDBETALING',
'autoplay_and_autocashout_ss': 'Valg mellem manuel og auto',
'autoplay_and_autocashout_p1': 'Spilleren kan aktivere autosspin, hvor et væddemål automatisk placeres hver runde med samme indsats som sidst.',
'autoplay_and_autocashout_p2': 'En auto-udbetalingsmultiplikator kan vælges, og når den nås, udbetales automatisk, hvis spilleren ikke rammes før.',
'autoplay_and_autocashout_p3': 'Det maksimale antal autospin-runder er ',
'autoplay_button_label': 'For at starte, vælg en bane.',
'min_bet_amount_is': 'Minimum indsats er',
'bonus_rounds': 'bonus runder',
'bonus_rounds_ss': 'Bonus runder med gyldighedsperiode',
'bonus_rounds_p1': 'En spiller kan tildeles bonusrunder (gratis spil) via en casino-kampagne. Et popup-vindue informerer om antal, indsats og gyldighed.',
'bonus_rounds_p2': 'Når de er tildelt, kan spilleren selv vælge, hvornår bonusrunden startes. Når den starter, placeres en automatisk indsats, og spilleren kan udbetale når som helst.',
'bonus_rounds_p3': 'Bonusrunder kan have en tidsbegrænsning, hvorefter de bliver ugyldige. Gyldighedsperioden vises under bonusrunden.',
'bonus_rounds_p4': 'Inaktivitet kan annullere en aktiv bonusrunde. I så fald reduceres antallet, men saldoen forbliver den samme.',
'valid_until': 'gyldig til',
'bonus': 'bonus',
'rounds': 'runder',
'win_eur': 'vind EUR',
'complete_your_bet': 'Afslut venligst dit væddemål først',
'complete_auto_play': 'Afslut venligst dit autosspil først',
'yes': 'ja',
'no': 'nej',
'play_bonus_rounds': 'Spil bonusrunder?',
'bet_history': 'Væddemålshistorik',
'jackpot_history': 'Jackpothistorik',
'ticket_id': 'Billet-ID',
'created': 'oprettet tid',
'currency': 'valuta',
'bet': 'indsats',
'bet_eur': 'indsats EUR',
'lanes': 'baner',
'cars': 'biler',
'multiplier': 'multiplikator',
'win': 'gevinst',
'no_betting_history': 'Ingen væddemålshistorik fundet. Placér et væddemål, så vises det her.',
'no_jackpot_history': 'Ingen jackpothistorik tilgængelig.',
'date': 'dato',
'user': 'bruger',
'bet_already_active': 'Væddemål allerede aktivt',
'please_play_the_game_in_portait_mode': 'Spil venligst i portrætformat.',
'bonus_history': 'Bonushistorik',
'bonus_type': 'Bonustype',
'no_bonus_history': 'Ingen bonushistorik tilgængelig.',
'game_menu': 'Spilmenu',
'game_menu_ss': 'Fra venstre: Hjem, Væddemålshistorik, Spilleregler, Genvejstaster, Lydindstillinger, Musik',
'game_menu_p1': 'Via spilmenuen kan spillere styre lyd, genvejstaster, samt åbne spil- og bonushistorik.',
'game_menu_p2': 'Spilhistorikken viser tidligere væddemål og bonusser.',
'multisession_title': 'Multisession er ikke tilladt',
'multisession_message': 'Din session er blevet afsluttet, fordi den samme konto blev åbnet i en anden fane eller et andet vindue.',
'session_inactivity_warning': 'På grund af inaktivitet udløber din session snart.',
'autoplay_confirmation': 'Samlet beløb for autoplay-runder',
'balance_before': 'Saldo før',
'balance_after': 'Saldo efter',

};
langArr.nl = { 
'loading': 'Laden',
'hotkeys': 'Sneltoetsen',
'hotkeys_enabled': 'Sneltoetsen ingeschakeld',
'enable_hotkeys_checkbox': 'Schakel onderstaande sneltoetsen in door dit vakje aan te vinken.',
'make_bet': 'Plaats een inzet',
'double_bet': 'Verdubbel inzetbedrag',
'halve_bet': 'Halveer inzet',
'min_bet': 'Minimale inzet',
'cashout_key': 'Uitbetalen',
'walk_next_line': 'Ga naar volgende rij',
'max': 'Max',
'easy': 'Makkelijk',
'medium': 'Gemiddeld',
'hard': 'Moeilijk',
'daredevil': 'Waaghals',
'max_profit': 'Maximale winst',
'manual': 'Handmatig',
'auto': 'Automatisch',
'bet_amount': 'Inzetbedrag',
'difficulty': 'Moeilijkheidsgraad',
'payout_on_win': 'Uitbetaling bij winst',
'number_of_bets': 'Aantal inzetten',
'on_win': 'Bij winst',
'on_loss': 'Bij verlies',
'stop_on_profit': 'Stop bij winst',
'stop_on_loss': 'Stop bij verlies',
'reset': 'Resetten',
'increase_by': 'Verhogen met',
'cashout': 'UITBETALEN',
'start_game': 'INZETTEN',
'start_auto_game': 'START',
'difficulity_info': 'Moeilijkheidsinformatie',
'chance_collision': 'Kans op botsing per spel',
'evry_25_lane': 'voor elke 25 rijen',
'insufficient_funds': 'Onvoldoende saldo',
'cashout_inactivity': 'Automatische uitbetaling bij inactiviteit',
'time_running_out': 'De tijd loopt af! Speel nu of je ticket wordt automatisch ingetrokken binnen 30 seconden',
'there_was_error': 'ER IS EEN FOUT OPGETREDEN, PROBEER OPNIEUW OF HERLAAD',
'detailed_game_rules': 'Gedetailleerde spelregels',
'general_rules': 'ALGEMENE REGELS',
'general_rules_p1': '• De vermenigvuldiger begint bij 1 en loopt op tot ',
'general_rules_p2': '• Winst wordt berekend door de inzet te vermenigvuldigen met de vermenigvuldiger die bij elke stap wordt weergegeven.',
'general_rules_p3': '• Als de maximale uitbetaling is bereikt, wordt het spel automatisch uitbetaald op het maximale bedrag.',
'progressive_jackpot': 'PROGRESSIEVE JACKPOT',
'progressive_jackpot_ss': 'De jackpot-rij en mogelijke winst',
'progressive_jackpot_p1': '% van elke inzet gaat naar het progressieve jackpotfonds.',
'progressive_jackpot_p2': 'De jackpot wordt toegekend met behulp van een "Mystery" of "must-hit-by" mechanisme. De waarde van elke "must-hit-by" jackpot wordt onmiddellijk na het winnen van de vorige jackpot bepaald door een willekeurige getallengenerator en als versleutelde waarde opgeslagen in de externe database. De waarde is versleuteld en dus verborgen en onbekend.',
'progressive_jackpot_p3': 'Zodra de "must-hit-by" waarde is bereikt, krijgt de eerste speler die daarna een inzet plaatst de kans om de jackpot te winnen. Een jackpotsymbool verschijnt op een willekeurige rij, en de jackpot wordt gewonnen als de speler die rij bereikt. Als de speler de rij met het jackpotsymbool niet bereikt door uitbetaling of botsing, zal de volgende willekeurige speler de kans krijgen. Dit proces wordt herhaald totdat de jackpot is gewonnen. Slechts één ticket/speler kan de jackpot winnen.',
'progressive_jackpot_p4': 'OPMERKING: De bonusronde draagt niet bij aan het jackpotfonds. Tijdens de bonusronde kan de jackpot niet worden gewonnen.',
'showdown': 'SHOWDOWN',
'showdown_ss': 'Rood vak, locatie van zekere botsing',
'showdown_p1': 'Na uitbetaling verschijnt een rood vak op de locatie waar de botsing zou hebben plaatsgevonden als de speler verder was gegaan.',
'return_to_player': 'UITKERINGSAAN SPELER',
'return_to_player_p1': 'De theoretische uitkering aan de speler (RTP) is ',
'return_to_player_p2': 'RTP-percentages worden continu gecontroleerd en geverifieerd door onafhankelijke derden.',
'disconnection_policy': 'VERBINDINGSVERLIESBELEID',
'disconnection_policy_p1': 'Als de verbinding wordt verbroken na het plaatsen van een inzet, wordt de inzet niet onmiddellijk geannuleerd. Als de inactiviteit van de speler ',
'disconnection_policy_p2': 'bereikt, wordt de inzet automatisch uitbetaald en het bedrag bijgeschreven op het spelersaccount.',
'network_latency': 'NETWERKLATENTIE',
'network_latency_p1': 'Netwerkvertraging is een onvermijdelijk onderdeel van internetverbindingen. We beschouwen alle inzetten en uitbetalingen als geldig op het moment dat ze onze server bereiken, ongeacht de duur van de vertraging.',
'sound': 'GELUID',
'sound_p1': 'Het spel bevat achtergrondmuziek en geluidseffecten. Als je deze wilt uitschakelen, kan dat via de spelmenu-iconen.',
'error_handling': 'FOUTAFHANDELING',
'error_handling_p1': 'In geval van een fout zal ons ondersteuningsteam proberen het probleem zo snel mogelijk op te lossen. In geval van een spelprobleem worden alle inzetten geannuleerd en inzetbedragen terugbetaald.',
'max_payout': 'Maximale uitbetaling is ',
'max_bet_is': 'Maximale inzet is ',
'min_bet_is': 'Minimale inzet is ',
'per_bet': 'per inzet.',
'malfunction_voids': 'Storingen maken alle uitbetalingen en spellen ongeldig.',
'attention_jackpot': 'Let op, jackpot op rij ',
'lane': 'rij',
'congratulations': 'gefeliciteerd',
'you_won': 'je hebt gewonnen',
'balance': 'saldo',
'time': 'tijd',
'jackpot': 'jackpot',
'escaped': 'GEVLUCHT',
'max_win': 'MAXIMALE WINST',
'check_internet': 'Controleer je internetverbinding',
'websocket_disconected': 'Websocket verbroken',
'websocket_connection_error': 'Websocket verbindingsfout!',
'session_expired': 'Sessie is verlopen, herlaad de pagina',
'remaining_bets': 'Resterende inzetten',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOSPELEN EN AUTO-UITBETALING',
'autoplay_and_autocashout_ss': 'Selectie tussen handmatig en automatisch spelen',
'autoplay_and_autocashout_p1': 'Een speler kan de automatische speeloptie activeren waarbij automatisch wordt ingezet bij elke nieuwe ronde met het vorige inzetbedrag.',
'autoplay_and_autocashout_p2': 'Een automatische uitbetalingsvermenigvuldiger kan worden ingesteld. Als deze is ingesteld, betaalt het spel automatisch uit zodra de speler de geselecteerde vermenigvuldiger bereikt (mits niet geraakt).',
'autoplay_and_autocashout_p3': 'Het maximale aantal automatische speelrondes is ',
'autoplay_button_label': 'Om te beginnen, kies een rij.',
'min_bet_amount_is': 'Minimale inzet is',
'bonus_rounds': 'bonus rondes',
'bonus_rounds_ss': 'De bonusrondes met geldigheidsperiode',
'bonus_rounds_p1': 'Een speler kan bonusrondes (gratis inzetten) krijgen op basis van een casinopromotie. Een pop-up verschijnt met het aantal inzetten, bedrag per inzet en eventueel de geldigheidsperiode.',
'bonus_rounds_p2': 'Zodra ze zijn toegekend, kan de speler kiezen wanneer de bonusronde start. Zodra gestart, wordt automatisch de gespecificeerde inzet geplaatst en kan de speler op elk moment uitbetalen.',
'bonus_rounds_p3': 'Bonusrondes kunnen een tijdslimiet hebben waarna ze ongeldig worden. De geldigheidsperiode (indien aanwezig) wordt onder de bonusronde weergegeven.',
'bonus_rounds_p4': 'Inactiviteit van de speler kan leiden tot annulering van een actieve bonusronde. Het aantal bonusrondes neemt dan af, terwijl het saldo gelijk blijft.',
'valid_until': 'geldig tot',
'bonus': 'bonus',
'rounds': 'rondes',
'win_eur': 'winst EUR',
'complete_your_bet': 'Voltooi eerst je inzet',
'complete_auto_play': 'Voltooi eerst je automatisch spel',
'yes': 'ja',
'no': 'nee',
'play_bonus_rounds': 'Bonusrondes spelen?',
'bet_history': 'Inzetgeschiedenis',
'jackpot_history': 'Jackpotgeschiedenis',
'ticket_id': 'Ticket ID',
'created': 'aanmaaktijd',
'currency': 'valuta',
'bet': 'inzet',
'bet_eur': 'inzet EUR',
'lanes': 'rijen',
'cars': 'auto’s',
'multiplier': 'vermenigvuldiger',
'win': 'winst',
'no_betting_history': 'Geen inzetgeschiedenis gevonden. Plaats een inzet en deze verschijnt hier.',
'no_jackpot_history': 'Geen jackpotgeschiedenis beschikbaar.',
'date': 'datum',
'user': 'gebruiker',
'bet_already_active': 'Inzet al actief',
'please_play_the_game_in_portait_mode': 'Speel het spel in portretmodus.',
'bonus_history': 'Bonushistorie',
'bonus_type': 'Bonustype',
'no_bonus_history': 'Geen bonushistorie beschikbaar.',
'game_menu': 'Spelmenu',
'game_menu_ss': 'Van links: Start, Inzetgeschiedenis, Spelregels, Sneltoetsen, Geluidseffecten, Muziek',
'game_menu_p1': 'Via het spelmenu kunnen spelers geluidsopties, sneltoetsen beheren en inzet- en spelgeschiedenis bekijken.',
'game_menu_p2': 'De spelgeschiedenis toont een venster met eerdere inzetten en bonusgeschiedenis.',
'multisession_title': 'Meerdere sessies zijn niet toegestaan',
'multisession_message': 'Uw sessie is beëindigd omdat hetzelfde account in een ander tabblad of venster werd geopend.',
'session_inactivity_warning': 'Vanwege inactiviteit verloopt uw sessie binnenkort.',
'autoplay_confirmation': 'Totaalbedrag voor autoplay-rondes',
'balance_before': 'Saldo vóór',
'balance_after': 'Saldo na',

};
langArr.sk = {
'loading': 'Načítava sa',
'hotkeys': 'Klávesové skratky',
'hotkeys_enabled': 'Klávesové skratky povolené',
'enable_hotkeys_checkbox': 'Povoľte klávesové skratky nižšie zaškrtnutím tohto políčka.',
'make_bet': 'Urobiť stávku',
'double_bet': 'Zdvojnásobiť stávku',
'halve_bet': 'Znížiť stávku na polovicu',
'min_bet': 'Minimálna stávka',
'cashout_key': 'Vyplatiť',
'walk_next_line': 'Prejsť na ďalší riadok',
'max': 'Max',
'easy': 'Ľahká',
'medium': 'Stredná',
'hard': 'Ťažká',
'daredevil': 'Odvážlivec',
'max_profit': 'Maximálny zisk',
'manual': 'Manuálne',
'auto': 'Automaticky',
'bet_amount': 'Výška stávky',
'difficulty': 'Obtiažnosť',
'payout_on_win': 'Výplata pri výhre',
'number_of_bets': 'Počet stávok',
'on_win': 'Pri výhre',
'on_loss': 'Pri prehre',
'stop_on_profit': 'Zastaviť pri zisku',
'stop_on_loss': 'Zastaviť pri strate',
'reset': 'Resetovať',
'increase_by': 'Zvýšiť o',
'cashout': 'VYPLATIŤ',
'start_game': 'STÁVKA',
'start_auto_game': 'ŠTART',
'difficulity_info': 'Informácie o obtiažnosti',
'chance_collision': 'Šanca na kolíziu na hru',
'evry_25_lane': 'na každých 25 dráh',
'insufficient_funds': 'Nedostatok prostriedkov',
'cashout_inactivity': 'Čiastočná výplata pri neaktivite',
'time_running_out': 'Čas sa kráti! Hraj teraz alebo bude tvoj lístok automaticky stiahnutý za 30 sekúnd',
'there_was_error': 'DOŠLO K CHYBE, SKÚSTE ZNOVA ALEBO OBNOVTE',
'detailed_game_rules': 'Podrobné pravidlá hry',
'general_rules': 'VŠEOBECNÉ PRAVIDLÁ',
'general_rules_p1': '• Násobiteľ začína na 1 a stúpa až do ',
'general_rules_p2': '• Výhry sa počítajú vynásobením vkladu s násobiteľom zobrazeným na každom kroku.',
'general_rules_p3': '• Ak sa dosiahne maximálna výhra, hra sa automaticky ukončí s maximálnou výplatou.',
'progressive_jackpot': 'PROGRESÍVNY JACKPOT',
'progressive_jackpot_ss': 'Jackpot dráha a možná výhra',
'progressive_jackpot_p1': '% z každej stávky ide do fondu progresívneho jackpotu.',
'progressive_jackpot_p2': 'Jackpot sa udeľuje pomocou mechaniky "Mystery" alebo "must-hit-by". Hodnota každého jackpotu "must-hit-by" sa určuje okamžite po predchádzajúcej výhre generátorom náhodných čísel a uloží sa ako šifrovaná hodnota do vzdialenej databázy. Hodnota je skrytá a nie je známa.',
'progressive_jackpot_p3': 'Keď sa dosiahne hodnota "must-hit-by", prvý hráč, ktorý následne uzavrie stávku, má šancu vyhrať jackpot. Symbol jackpotu sa objaví na náhodnej dráhe a jackpot sa vyhrá, ak hráč dosiahne dráhu so symbolom. Ak hráč nedosiahne dráhu so symbolom (vyplatením alebo zlyhaním), ďalší náhodný hráč uvidí symbol a môže vyhrať. Proces sa opakuje, kým niekto nevyhrá jackpot. Jackpot môže vyhrať iba jeden hráč.',
'progressive_jackpot_p4': 'POZNÁMKA: Bonusové kolo neprispieva do jackpotového fondu. Počas bonusového kola nemožno jackpot vyhrať.',
'showdown': 'SÚBOJ',
'showdown_ss': 'Červený štvorec, miesto určitej kolízie',
'showdown_p1': 'Po vyplatení hráča sa na mieste, kde by došlo ku kolízii, zobrazí červený štvorec.',
'return_to_player': 'NÁVRAT HRÁČOVI',
'return_to_player_p1': 'Celkový teoretický návrat hráčovi (RTP) je ',
'return_to_player_p2': 'Percentá RTP sú neustále monitorované a overované nezávislými tretími stranami.',
'disconnection_policy': 'PRAVIDLÁ PRI ODPOJENÍ',
'disconnection_policy_p1': 'Ak sa preruší spojenie po uzavretí stávky, stávka sa okamžite nezruší. Ak neaktivita hráča dosiahne ',
'disconnection_policy_p2': 'stávka sa automaticky vyplatí a kredity sa pripíšu na účet hráča.',
'network_latency': 'SIEŤOVÁ LATENCIA',
'network_latency_p1': 'Sieťová latencia je nevyhnutná súčasť pripojenia na internet. Všetky stávky a výplaty považujeme za platné iba v momente, keď dorazia na náš server, bez ohľadu na dĺžku latencie.',
'sound': 'ZVUK',
'sound_p1': 'Hra je navrhnutá s krásnou hudbou a zvukovými efektmi. Ak chcete hudbu alebo efekty vypnúť, môžete tak urobiť cez ikony v menu hry.',
'error_handling': 'RIEŠENIE CHÝB',
'error_handling_p1': 'V prípade chyby sa náš tím pokúsi problém vyriešiť čo najskôr a pokračovať v hre. V prípade problému priamo v hre budú všetky stávky zrušené a vklady vrátené hráčom.',
'max_payout': 'Maximálna výplata je ',
'max_bet_is': 'Max stávka je ',
'min_bet_is': 'Min stávka je ',
'per_bet': 'na stávku.',
'malfunction_voids': 'Porucha ruší všetky výhry a hry.',
'attention_jackpot': 'Pozor, Jackpot na dráhe ',
'lane': 'dráha',
'congratulations': 'gratulujeme',
'you_won': 'vyhral si',
'balance': 'zostatok',
'time': 'čas',
'jackpot': 'jackpot',
'escaped': 'UTEKOL',
'max_win': 'MAX VÝHRA',
'check_internet': 'Skontrolujte svoje internetové pripojenie',
'websocket_disconected': 'Websocket odpojený',
'websocket_connection_error': 'Chyba pripojenia Websocket!',
'session_expired': 'Relácia vypršala, prosím obnovte',
'remaining_bets': 'Zostávajúce stávky',
'stop_autoplay': 'STOP',
'autoplay_and_autocashout': 'AUTOMATICKÁ HRA A VYPLATENIE',
'autoplay_and_autocashout_ss': 'Výber medzi manuálnou a automatickou hrou',
'autoplay_and_autocashout_p1': 'Hráč si môže aktivovať automatickú hru, kde sa stávka opakuje každé nové kolo s predchádzajúcou výškou stávky.',
'autoplay_and_autocashout_p2': 'Na obrazovke hry možno nastaviť násobiteľ automatického vyplatenia. Ak sa dosiahne a hráč nebol vyradený, hra sa automaticky vyplatí.',
'autoplay_and_autocashout_p3': 'Maximálny počet kôl automatickej hry je ',
'autoplay_button_label': 'Na začiatok si vyber dráhu.',
'min_bet_amount_is': 'Minimálna výška stávky je',
'bonus_rounds': 'bonusové kolá',
'bonus_rounds_ss': 'Bonusové kolá s dobou platnosti',
'bonus_rounds_p1': 'Hráč môže získať bonusové kolo (napr. bezplatnú stávku) na základe promo akcie kasína. Na obrazovke sa zobrazí okno s oznámením o bonusových kolách, počte stávok, výške vkladu a prípadnej dobe platnosti.',
'bonus_rounds_p2': 'Po pridelení si hráč môže zvoliť, kedy začne bonusové kolo. Po začatí bonusového kola sa automaticky uzavrie stávka so zadaným vkladom a je na hráčovi, kedy si vyberie výplatu.',
'bonus_rounds_p3': 'Bonusové kolá môžu mať časové obmedzenie, po ktorom sa stanú neplatnými. Prípadná doba platnosti sa zobrazí pod bonusovým kolom.',
'bonus_rounds_p4': 'Nečinnosť hráča môže viesť k zrušeniu aktívneho bonusového kola. V tom prípade sa počet bonusových kôl zníži, ale zostatok hráča ostane rovnaký.',
'valid_until': 'platné do',
'bonus': 'bonus',
'rounds': 'kolá',
'win_eur': 'výhra EUR',
'complete_your_bet': 'Najprv dokončite svoju stávku',
'complete_auto_play': 'Najprv dokončite svoju automatickú hru',
'yes': 'áno',
'no': 'nie',
'play_bonus_rounds': 'Hrať bonusové kolá?',
'bet_history': 'História stávok',
'jackpot_history': 'História jackpotov',
'ticket_id': 'ID lístka',
'created': 'čas vytvorenia',
'currency': 'mena',
'bet': 'stávka',
'bet_eur': 'stávka EUR',
'lanes': 'dráhy',
'cars': 'autá',
'multiplier': 'násobiteľ',
'win': 'výhra',
'no_betting_history': 'Nenašla sa žiadna história stávok. Urobte stávku a objaví sa tu.',
'no_jackpot_history': 'História jackpotov nie je dostupná.',
'date': 'dátum',
'user': 'hráč',
'bet_already_active': 'Stávka je už aktívna',
'please_play_the_game_in_portait_mode': 'Prosím, hrajte hru v režime na výšku.',
'bonus_history': 'História bonusov',
'bonus_type': 'Typ bonusu',
'no_bonus_history': 'História bonusov nie je dostupná.',
'game_menu': 'Menu hry',
'game_menu_ss': 'Zľava: Domov, História stávok, Pravidlá hry, Klávesové skratky, Nastavenia zvuku, Hudba',
'game_menu_p1': 'Cez menu hry môžu hráči ovládať zvuk, klávesové skratky a otvárať históriu aj pravidlá hry.',
'game_menu_p2': 'História hry zobrazí okno s predchádzajúcimi stávkami a bonusmi.',
'multisession_title': 'Multisession nie je povolený',
'multisession_message': 'Vaša relácia bola ukončená, pretože rovnaký účet bol otvorený v inom okne alebo karte.',
'session_inactivity_warning': 'V dôsledku nečinnosti vaša relácia čoskoro vyprší.',
'autoplay_confirmation': 'Celková suma pre kolá automatickej hry',
'balance_before': 'Zostatok pred',
'balance_after': 'Zostatok po',

};
